<template>
  <v-app>

    <!-- Elerta de que no puede acceder a esa ruta -->
    <v-snackbar
      v-model="alerta.mostrar"
      :color="alerta.tipo"
      timeout="4000"
      top
    >
      {{ alerta.mensaje }}
    </v-snackbar>

    
    <!-- Barra principal -->
    <v-app-bar
      app
      :color="esAmbienteStaging ? 'orange darken-2' : 'white'"
      :dark="esAmbienteStaging"
      class="elevation-0"
      v-if="getLogeado"
    >
      <!-- src="@/assets/banner_app.png"  -->
      <!-- class ="ma-5 mt-3" style="border-radius: 10px;" -->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <span v-if="esAmbienteStaging" class="text-caption font-weight-bold mr-2">AMBIENTE</span>
      v {{ appVersion }}
      <v-spacer></v-spacer>

      <div class="app-bar-actions">
        <div class="app-bar-action" v-if="!esPuestoCalidadMenu">
          <v-badge
            dot
            overlap
            offset-x="8"
            offset-y="8"
            :color="mostrarAlertaNovedades ? 'error' : 'transparent'"
            :value="mostrarAlertaNovedades"
          >
            <v-btn
              icon
              small
              class="app-bar-btn"
              :title="mostrarAlertaNovedades ? 'Hay novedades del sistema hoy' : 'Novedades del sistema'"
              :to="{ name: 'TimelineCambios' }"
            >
              <v-icon color="indigo darken-2">mdi-new-box</v-icon>
            </v-btn>
          </v-badge>
        </div>

        <div class="app-bar-action">
          <DiagnosticoSistemaAppBar />
        </div>

        <div class="app-bar-action">
          <PruebaWhatsappRendimientoAppBar />
        </div>

        <div class="app-bar-action">
          <v-btn
            icon
            small
            class="app-bar-btn"
            title="Reportar problema"
            @click="abrirBugReport"
          >
            <v-icon color="warning">mdi-bug</v-icon>
          </v-btn>
        </div>

        <div v-if="hayCumpleHoy" class="app-bar-action">
          <v-btn
            icon
            small
            class="app-bar-btn"
            title="Cumpleaños de hoy"
            @click="abrirModalCumple"
          >
            <v-icon color="pink darken-1">mdi-cake-variant</v-icon>
          </v-btn>
        </div>

        <div v-if="esReconocimientoMoisesHoy && reconocimientoHoraLista" class="app-bar-action">
          <v-btn
            icon
            small
            class="app-bar-btn"
            title="Reconocimiento de hoy"
            @click="abrirModalReconocimiento"
          >
            <v-icon color="amber darken-3">mdi-star</v-icon>
          </v-btn>
        </div>

        <div v-if="mostrarBtnPagosRechazados" class="app-bar-action">
          <v-btn
            icon
            small
            class="app-bar-btn"
            title="Pagos rechazados"
            @click="cargarPagosRechazados"
          >
            <v-icon color="primary">mdi-cash-register</v-icon>
          </v-btn>
        </div>

        <div class="app-bar-action">
          <v-badge
            overlap
            bordered
            offset-x="14"
            offset-y="14"
            :color="mostrarBadgeNotificaciones ? 'error' : 'transparent'"
            :content="notificacionesBadgeContent"
            :value="mostrarBadgeNotificaciones"
          >
            <v-menu offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  class="app-bar-btn"
                  title="Notificaciones"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary">mdi-bell</v-icon>
                </v-btn>
              </template>
              <v-card class="mx-auto overflow-y-auto app-bar-notifications-menu" max-width="320" tile>
                <v-list three-line nav>
                  <v-list-item v-if="!notificaciones.length" disabled>
                    <v-list-item-content>
                      <v-list-item-title>Sin notificaciones</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    v-for="(noti, i) in notificaciones"
                    :key="noti.id || i"
                    nav
                    link
                    class="app-bar-notif-item"
                    @click="verNotificacion(noti)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon :color="noti.visto == 0 ? 'red' : 'grey'">mdi-circle-medium</v-icon>
                        {{ noti.titulo }}
                      </v-list-item-title>
                      <v-list-item-subtitle v-html="noti.mensaje"></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-badge>
        </div>

        <div
          v-if="mostrarBtnCalendario"
          class="app-bar-action"
        >
          <v-badge
            overlap
            bordered
            offset-x="14"
            offset-y="14"
            color="error"
            :content="actividadesHoyBadge"
            :value="actividadesHoy > 0"
          >
            <v-btn
              icon
              small
              class="app-bar-btn"
              title="Calendario"
              @click="dialogCalendario.estatus = true"
            >
              <v-icon color="orange darken-1">mdi-calendar-check</v-icon>
            </v-btn>
          </v-badge>
        </div>

        <div
          v-if="carrito_activo && ![1].includes(getdatosUsuarioERPERP && getdatosUsuarioERPERP.iderp)"
          class="app-bar-action"
        >
          <v-badge
            overlap
            bordered
            offset-x="14"
            offset-y="14"
            color="error"
            :content="carritoBadgeContent"
            :value="getCarrito.length > 0"
          >
            <v-btn
              icon
              small
              class="app-bar-btn"
              title="Carrito"
              @click.stop="ver_carrito()"
            >
              <v-icon color="primary">mdi-shopping</v-icon>
            </v-btn>
          </v-badge>
        </div>

        <div
          v-if="mostrarBtnBitacora"
          class="app-bar-action"
        >
          <v-btn
            icon
            small
            class="app-bar-btn"
            title="Bitácora"
            @click.stop="menubitacora.estatus = true"
          >
            <v-icon color="cyan darken-1">mdi-notebook</v-icon>
          </v-btn>
        </div>
      </div>
    </v-app-bar>

    <!-- Menu lateral izquierdo -->
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      app
      v-if="getLogeado"
      class="elevation-0 pb-5"
    >
      <!-- src="@/assets/images/fondo/fondo_lateral_navidad.png" -->
      <!-- Datos del empleado -->
      <v-list-item class="pt-4 px-1" >
        <v-list-item-content>
          <v-img src="@/assets/images/logos/logo.png" v-if="!mini"></v-img>
          <v-avatar
            size="40"
            v-else
            color="white"
          >
            <img src="@/assets/images/logos/logo_redondo.png">
          </v-avatar>
        </v-list-item-content>

        <v-btn icon @click.stop="mini = !mini" color="primary">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item class="px-2">
        <v-list-item-avatar>
          <v-img
            :src="avatar"
          ></v-img>
        </v-list-item-avatar>

        <v-list-item-content v-if="getdatosUsuarioERPERP">
          <v-list-item-title>
            {{ getdatosUsuarioERPERP.nombre_usuario + " " + getdatosUsuarioERPERP.apellido_usuario }}
          </v-list-item-title>
          <v-list-item-subtitle>{{ getdatosUsuarioERPERP.puesto }}</v-list-item-subtitle>
          <v-list-item-subtitle v-if="getdatosUsuarioERPERP.plantel">{{ getdatosUsuarioERPERP.plantel }}</v-list-item-subtitle>
          <v-list-item-subtitle v-if="esAmbienteStaging" class="mt-1">
            <v-chip x-small color="orange darken-2" dark label class="px-2">{{ etiquetaAmbiente }}</v-chip>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <EstatusRecepcionSidebar v-if="!mini" />

      <div :class="`text-center text-body-1 ${ escuela == 1 ? 'colorinbi': 'colorfast' } white--text mb-3`" v-if="!mini">
        <span>{{ escuela == 1 ? 'INBI SCHOOL': 'FAST ENGLISH' }}</span>
      </div>

      <!-- <div class="text--center" align="center">
        <v-spacer></v-spacer>
        <v-img src="@/assets/icons8-bigote-96.png" width="120" height="45"></v-img>
        <v-spacer></v-spacer>
      </div> -->

      <v-autocomplete
        v-if="!mini && mostrarMenusLateralesExtra"
        outlined
        dense
        clearable
        v-model="search"
        :items="menuBusqueda"
        label="Búscar"
        persistent-hint
        item-text="title"
        item-value="path"
        class="pa-1"
        rounded
        hide-details
      >
      </v-autocomplete>

      <v-list v-if="mostrarMenusLateralesExtra" dense nav class="mr-0 mb-1">
        <v-list-item :to="{ name: 'TimelineCambios' }" class="indigo darken-1 white--text" dark>
          <v-list-item-icon>
            <v-badge
              dot
              overlap
              :color="mostrarAlertaNovedades ? 'error' : 'transparent'"
              :value="mostrarAlertaNovedades"
            >
              <v-icon color="white">mdi-new-box</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Novedades del sistema
              <v-chip
                v-if="mostrarAlertaNovedades"
                x-small
                color="error"
                class="ml-1 px-2"
                label
              >
                Hoy
              </v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list nav dense class="mr-0">
        <v-list-group
          v-for="item in menu"
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.action"
          no-action
        >
          <!-- TITULO EN GENERAL -->
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <!-- LISTA DE MENUS -->
          <v-list dense nav>

            <!-- MENU DIRECTO -->
            <v-list-item
              v-for="cat in item.items"
              :key="cat.title"
              :to="{ name: cat.path }"
              :color="`${ cat.color ? 'white' : 'primary' }`"
              :class="` ${ cat.color ? cat.color : 'cyan lighten-5' }`"
              v-if="!cat.items"
            >
              <v-list-item-icon >
                <v-icon color="primary">mdi mdi-circle-medium theme--light</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="cat.title"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group
              v-for="cat in item.items"
              :key="cat.title"
              v-model="cat.active"
              :prepend-icon="cat.action"
              no-action
              v-if="cat.items"
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title v-text="cat.title"></v-list-item-title>
                </v-list-item-content>
              </template>

              <v-list-item
                v-for="child in cat.items"
                :key="child.title"
                :to="{ name: child.path }"
                :color="`${ child.color ? 'white' : 'primary' }`"
                :class="`pl-2 ${ child.color ? child.color : 'cyan lighten-5' }`"
              >
                <v-list-item-icon>
                  <v-icon color="primary">mdi mdi-circle-medium theme--light</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="child.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-list-group>
      </v-list>

      <v-list v-if="mostrarMenusLateralesExtra" dense nav class="mr-0">
        <v-list-item @click="dialogDirectorio.estatus = true" class="teal accent-3 white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-account-box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Directorio General</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list v-if="mostrarMenusLateralesExtra" dense nav class="mr-0">
        <v-list-item :to="{ name:'PreguntasUsuario' }" class="pink lighten-2 white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-help</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Preguntas Frecuentes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Manuales / RI: no aplica a puesto Calidad -->
      <v-list dense nav class="mr-0" v-if="mostrarMenusLateralesExtra && getdatosUsuarioERPERP && getdatosUsuarioERPERP.idpuesto == 10" >
        <v-list-item :to="{ name:'ManualesTeachers' }" class="blue lighten-2" dark>
          <v-list-item-icon>
            <v-icon>mdi-book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Manuales</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list dense nav class="mr-0" v-else-if="mostrarMenusLateralesExtra && getdatosUsuarioERPERP && getdatosUsuarioERPERP.idpuesto == 19" >
        <v-list-item :to="{ name: 'rigrupos' }" class="deep-purple darken-2 white--text mb-1" dark>
          <v-list-item-icon>
            <v-icon color="white">mdi-chart-box-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>RI Grupos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'nigrupos' }" class="teal darken-2 white--text mb-1" dark>
          <v-list-item-icon>
            <v-icon color="white">mdi-account-multiple-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>NI Grupos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name:'ManualesRecepcionista' }" class="blue lighten-2" dark>
          <v-list-item-icon>
            <v-icon>mdi-book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Manuales</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list dense nav class="mr-0" v-else-if="mostrarMenusLateralesExtra && getdatosUsuarioERPERP && [18,19,11].includes( getdatosUsuarioERPERP.idpuesto ) " >
        <v-list-item :to="{ name:'ReglamentoTeachers' }" class="orange" dark>
          <v-list-item-icon>
            <v-icon>mdi-book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Reglamento Teacher</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list dense nav class="mr-0" v-else-if="mostrarMenusLateralesExtra">
        <v-list-item :to="{ name:'Manuales' }" class="blue lighten-2" dark>
          <v-list-item-icon>
            <v-icon>mdi-book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Manuales</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list v-if="mostrarMenusLateralesExtra" dense nav class="mr-0">
        <v-list-item :to="{ name:'Reglamento' }" class="teal accent-4 white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Reglamento</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list dense nav class="mr-0" v-if="mostrarMenusLateralesExtra && getdatosUsuarioERPERP && [10,11].includes( getdatosUsuarioERPERP.idpuesto ) " >
        <v-list-item :to="{ name:'Calendario' }" class="purple" dark>
          <v-list-item-icon>
            <v-icon>mdi-book</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Calendario</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- REGLAMENTO -->
      <v-list dense nav class="mr-0">
        <v-list-item @click="salir" class="red white--text" dark>
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Salir</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>


      <div>
        <v-card align="center" class="text--center elevation-0" @click="irAGlobal()">
          <br/>
          <br/>
          <div class="black--text mb-2">Diseñado y desarrollado por</div>
          <v-img src="@/assets/globalsyntax.png" width="60%"/>
        </v-card>
      </div>

    </v-navigation-drawer>

    <!-- DATOS DE TODO EL SISTEMA -->
    <v-main>
      <v-alert
        v-if="bloqueoValidacionFinanzasActivo"
        dense
        colored-border
        border="left"
        type="warning"
        elevation="2"
        class="ma-3 mb-0"
      >
        Sistema restringido: hay
        <strong>{{ bloqueoValidacionFinanzas.pendientes }}</strong>
        pago(s) sin validar con más de 36 horas desde su ingreso (desde 2026). Solo puedes usar Corte diario, Validación de pagos,
        Validación de ingresos y Estado de cuentas.
      </v-alert>
      <router-view />
    </v-main>

    <!-- Menu lateral derecho -->
    <v-navigation-drawer
      v-model="drawer2"
      v-if="tareas_activas"
      right
      temporary
      app
      class="elevation-3 mt-3 pb-5"
      style="border-radius: 10px;"
    >
      <template v-slot:prepend>
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-img
              :src="avatar"
            ></v-img>
          </v-list-item-avatar>

          <v-list-item-content v-if="getdatosUsuarioERPERP">
            <v-list-item-title>
              {{ getdatosUsuarioERPERP.nombre_usuario + " " + getdatosUsuarioERPERP.apellido_usuario }}
            </v-list-item-title>
            <v-list-item-subtitle>{{ getdatosUsuarioERPERP.puesto }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="getdatosUsuarioERPERP.plantel">{{ getdatosUsuarioERPERP.plantel }}</v-list-item-subtitle>
            <v-list-item-subtitle v-if="esAmbienteStaging" class="mt-1">
              <v-chip x-small color="orange darken-2" dark label class="px-2">{{ etiquetaAmbiente }}</v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-subheader><strong>Hoy  | {{countTareas}} | </strong></v-subheader>
      <div v-for="(tarea, i) in tareas_programadas" :key="i" v-if="tarea.hoy == 1">
        <v-card class="elevation-0">
          <v-card-text class="pt-0">
            <div class="text-body-1">
              <strong>{{ tarea.folio }}</strong><br/>
              {{ tarea.nombre_completo }}<br/>
              <v-icon :color="tarea.cumplida == 1 ? 'red' : 'green'">mdi mdi-circle-medium theme--light</v-icon>
              {{ tarea.motivo }}<br/>
            </div>
            <div class="text-caption">{{ tarea.fecha + ' ' + tarea.tiempo }}</div>

            <v-btn color="primary" block small class="text-capitalize" @click="verProspecto(tarea)">Realizar</v-btn>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
      </div>
      <v-divider></v-divider>
      <v-subheader><strong>Restantes</strong> </v-subheader>
      <div v-for="(tarea, i) in tareas_programadas" :key="i" v-if="tarea.hoy == 0">
        <v-card class="elevation-0">
          <v-card-text class="pt-0">
            <div class="text-body-1">
              <strong>{{ tarea.folio }}</strong><br/>
              {{ tarea.nombre_completo }}<br/>
              <v-icon :color="tarea.cumplida == 1 ? 'red' : 'green'">mdi mdi-circle-medium theme--light</v-icon>
              {{ tarea.motivo }}<br/>
            </div>
            <div class="text-caption">{{ tarea.fecha + ' ' + tarea.tiempo }}</div>

            <v-btn color="primary" block small class="text-capitalize" @click="verProspecto(tarea)">Realizar</v-btn>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
      </div>
    </v-navigation-drawer>

    <!-- Menu tienda -->
    <v-navigation-drawer right temporary app v-model="$store.state.Carrito.carritovisible"  width="400px" v-if="carrito_activo">
      <div class="pa-2">
        <CARRITO/>
      </div>
    </v-navigation-drawer>

    <!-- Menu tienda -->
    <v-navigation-drawer v-if="getdatosUsuarioERPERP && [12, 18].includes( getdatosUsuarioERPERP.idpuesto )" right temporary app v-model="menubitacora.estatus"  width="400px" @input="onDrawerToggle">
      <div class="pa-2">
        <BITACORA ref="bitacora"/>
      </div>
    </v-navigation-drawer>

    <!-- Boton de navegación para prospectos -->
    <v-speed-dial
      v-if="getdatosUsuarioERPERP && [43,18,45,73,40].includes(getdatosUsuarioERPERP.idpuesto)"
      v-model="fab"
      fixed
      fab
      bottom
      right
    >
      <template v-slot:activator>
        <v-badge
          bordered
          color="green"
          overlap
          :content="getNuevosProspectos"
        >
          <v-btn
            v-model="fab"
            color="blue darken-2"
            dark
            fab
          >
            <v-icon>
              mdi-account-circle
            </v-icon>
          </v-btn>
        </v-badge>

      </template>
      <!-- Nuevo prospecto -->
      <v-btn
        fab
        dark
        small
        color="indigo"
        :to="{name:'Prospectos'}"
      >
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>

      <v-badge
        bordered
        color="error"
        overlap
        :content="countTareas"
        v-if="getdatosUsuarioERPERP && [11,18,67,73].includes( getdatosUsuarioERPERP.idpuesto )"
      >
        <v-btn
          fab
          small
          dark
          color="error"
          @click.stop="getTareasProgramadas()"
        >
          <v-icon>mdi-calendar-check</v-icon>
        </v-btn>
      </v-badge>
    </v-speed-dial>

    <!-- Botón para agregar un nuevo prospecto para la vendedora y recepcionista -->
    <v-btn
      v-if=" getdatosUsuarioERPERP && ( [19,18,73,11,40].includes(getdatosUsuarioERPERP.idpuesto) || [1794].includes(getdatosUsuarioERPERP.iderp) )"
      fixed
      fab
      bottom
      right
      color="green"
      dark
      @click="abrirDialogProspecto.estatus = true"
      style="margin-right: 65px;"
    >
      <v-icon>
        mdi-account-plus
      </v-icon>
    </v-btn>

    <AlertaSeguimiento   v-if="alertaSeguimiento.estatus"       :alertaSeguimiento="alertaSeguimiento"/>
    <NuevoProspecto      v-if="abrirDialogProspecto.estatus"    :abrirDialogProspecto="abrirDialogProspecto"/>

    <FaltaraTeacher
      v-if="alertaSinTeacher.estatus"
      :alertaSinTeacher="alertaSinTeacher"
    />

    <NuevaVenta
      v-show="alertaNuevaVenta.estatus"
      :alertaNuevaVenta="alertaNuevaVenta"
    />

    <NuevaRI
      v-show="alertaNuevaRI.estatus"
      :alertaNuevaRI="alertaNuevaRI"
    />

    <SinSeguimiento
      v-show="alertaSinSeguimiento.estatus"
      :alertaSinSeguimiento="alertaSinSeguimiento"
    />

    <AlertaEquipoUso
      v-show="alertaEquipoUso.estatus"
      :alertaEquipoUso="alertaEquipoUso"
    />

    <AlertaAccesoBloqueado
      :estatus="alertaAccesoBloqueado.estatus"
      :motivo="alertaAccesoBloqueado.motivo"
    />

    <EncuestaTwilioModal
      v-model="encuestaTwilio.abierta"
      @respondida="onEncuestaTwilioRespondida"
    />

    <dialogNotificacion
      v-if="dialogNotifica.estatus"
      :dialogNotifica="dialogNotifica"
      @getNotificaciones="getNotificaciones"
    />

    <MisTickets
      v-if="paramsTickets.estatus && ![568,31,334,1312,28,32].includes(getdatosUsuarioERPERP.iderp)"
      :paramsTickets="paramsTickets"
    />

    <MisComisiones
      v-if="paramsComisiones.estatus"
      :paramsComisiones="paramsComisiones"
    />

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <Calendario v-if="dialogCalendario.estatus" :dialogCalendario="dialogCalendario"/>

    <!-- DIALOGO DE CUMPLEAÑOS -->
    <v-dialog
      v-model="dialogCumple"
      max-width="520px"
      content-class="cumple-dialog"
      transition="dialog-transition"
    >

      <v-card class="cumple-card" :class="cumpleTemaClass" elevation="0">
        <v-card-text class="black--text pa-0">
          <div v-if="cumple && cumple.cumpleAnios" class="cumple-modal" :class="cumpleTemaClass">
            <div class="cumple-cake-stage" :key="'cake-' + dialogCumple">
              <span class="cumple-orb cumple-orb--1"></span>
              <span class="cumple-orb cumple-orb--2"></span>
              <span class="cumple-orb cumple-orb--3"></span>
              <span class="cumple-sparkle s1"></span>
              <span class="cumple-sparkle s2"></span>
              <span class="cumple-sparkle s3"></span>
              <span class="cumple-sparkle s4"></span>
              <div class="cumple-glow"></div>

              <!-- Confeti + globos (tras armar el pastel) -->
              <div class="cumple-fiesta" aria-hidden="true">
                <span class="fiesta-confetti c1"></span>
                <span class="fiesta-confetti c2"></span>
                <span class="fiesta-confetti c3"></span>
                <span class="fiesta-confetti c4"></span>
                <span class="fiesta-confetti c5"></span>
                <span class="fiesta-balloon b1"></span>
                <span class="fiesta-balloon b2"></span>
                <span class="fiesta-balloon b3"></span>
              </div>

              <div class="cumple-cake" aria-hidden="true">
                <svg class="cumple-cake-svg" viewBox="0 0 240 220" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="chocoBody" x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stop-color="#b57a5c"/>
                      <stop offset="50%" stop-color="#8f5a40"/>
                      <stop offset="100%" stop-color="#6d4330"/>
                    </linearGradient>
                    <linearGradient id="chocoFace" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stop-color="#c99274"/>
                      <stop offset="100%" stop-color="#9a6349"/>
                    </linearGradient>
                    <linearGradient id="icingBody" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stop-color="#ffffff"/>
                      <stop offset="100%" stop-color="#f4ebe3"/>
                    </linearGradient>
                    <radialGradient id="plateGrad" cx="50%" cy="40%" r="60%">
                      <stop offset="0%" stop-color="#ffffff"/>
                      <stop offset="100%" stop-color="#eadfd4"/>
                    </radialGradient>
                    <radialGradient id="flameGrad" cx="50%" cy="70%" r="55%">
                      <stop offset="0%" stop-color="#fff3a0"/>
                      <stop offset="45%" stop-color="#ffc14d"/>
                      <stop offset="100%" stop-color="#ff8c42"/>
                    </radialGradient>
                  </defs>

                  <!-- Boquilla -->
                  <g class="cake-spout">
                    <rect class="spout-a" x="106" y="2" width="28" height="16" rx="4"/>
                    <rect class="spout-b" x="112" y="14" width="16" height="14" rx="3"/>
                    <path class="spout-c" d="M115 28 L125 28 L128 38 L112 38 Z"/>
                    <ellipse class="spout-d" cx="120" cy="38" rx="10" ry="3.5"/>
                  </g>

                  <ellipse class="batter-drop drop-1" cx="120" cy="46" rx="10" ry="12" fill="#a06b52"/>
                  <ellipse class="batter-drop drop-2" cx="120" cy="46" rx="9" ry="11" fill="#8b5a44"/>
                  <ellipse class="batter-drop drop-3" cx="120" cy="46" rx="11" ry="10" fill="#b4785c"/>
                  <ellipse class="batter-drop drop-4" cx="120" cy="46" rx="9" ry="8" fill="#fffaf6"/>

                  <!-- Plato -->
                  <g class="cake-part cake-plate">
                    <ellipse cx="120" cy="208" rx="95" ry="9" fill="#cbb7a6" opacity="0.28"/>
                    <ellipse cx="120" cy="202" rx="90" ry="14" fill="url(#plateGrad)"/>
                    <ellipse cx="120" cy="198" rx="70" ry="7" fill="#fff" opacity="0.4"/>
                  </g>

                  <!-- Capa 1 (base) -->
                  <g class="cake-part cake-base">
                    <ellipse cx="120" cy="190" rx="80" ry="13" fill="#5f3a2a"/>
                    <path d="M40 158 C40 148 200 148 200 158 L200 190 C200 200 40 200 40 190 Z" fill="url(#chocoBody)"/>
                    <ellipse cx="120" cy="158" rx="80" ry="12" fill="url(#chocoFace)"/>
                    <path d="M180 162 C192 168 192 184 180 188 C190 180 190 168 180 162 Z" fill="#000" opacity="0.07"/>
                  </g>

                  <!-- Capa 2 (media) -->
                  <g class="cake-part cake-mid">
                    <ellipse cx="120" cy="158" rx="72" ry="9" fill="#fff8f1"/>
                    <path d="M50 128 C50 118 190 118 190 128 L190 158 C190 166 50 166 50 158 Z" fill="url(#chocoBody)"/>
                    <ellipse cx="120" cy="128" rx="70" ry="11" fill="url(#chocoFace)"/>
                    <path d="M170 132 C180 138 180 152 170 156 C178 148 178 138 170 132 Z" fill="#000" opacity="0.07"/>
                  </g>

                  <!-- Capa 3 (superior) -->
                  <g class="cake-part cake-top">
                    <ellipse cx="120" cy="128" rx="64" ry="8" fill="#fff8f1"/>
                    <path d="M60 100 C60 90 180 90 180 100 L180 128 C180 136 60 136 60 128 Z" fill="url(#chocoBody)"/>
                    <ellipse cx="120" cy="100" rx="60" ry="10" fill="url(#chocoFace)"/>
                    <path d="M162 104 C170 110 170 122 162 126 C168 120 168 110 162 104 Z" fill="#000" opacity="0.06"/>
                  </g>

                  <!-- Glaseado -->
                  <g class="cake-part cake-icing">
                    <path d="M60 100 C60 90 180 90 180 100 L180 114 C180 122 60 122 60 114 Z" fill="url(#icingBody)"/>
                    <ellipse cx="120" cy="96" rx="60" ry="11" fill="#ffffff"/>
                    <ellipse cx="98" cy="92" rx="18" ry="4" fill="#fff" opacity="0.55"/>
                    <path d="M68 102 C66 118 72 126 80 122 C76 112 74 106 72 102 Z" fill="url(#icingBody)"/>
                    <path d="M90 100 C86 128 98 136 108 128 C102 118 100 108 98 100 Z" fill="url(#icingBody)"/>
                    <path d="M122 98 C118 120 128 126 136 120 C132 110 130 102 128 98 Z" fill="url(#icingBody)"/>
                    <path d="M148 100 C144 132 158 140 168 130 C162 118 158 108 156 100 Z" fill="url(#icingBody)"/>
                    <circle cx="82" cy="94" r="2" fill="#ff9eb5"/>
                    <circle cx="112" cy="90" r="1.8" fill="#7ec8e3"/>
                    <circle cx="140" cy="92" r="2" fill="#ffd56a"/>
                    <circle cx="158" cy="96" r="1.6" fill="#9ad27a"/>
                  </g>

                  <!-- Vela simple -->
                  <g class="cake-part cake-candle">
                    <rect x="116" y="52" width="8" height="44" rx="3" fill="#fff7f0"/>
                    <rect x="117.5" y="52" width="2.5" height="44" rx="1" fill="#fff" opacity="0.45"/>
                    <line x1="120" y1="47" x2="120" y2="52" stroke="#c9a27c" stroke-width="1.3" stroke-linecap="round"/>
                    <ellipse class="cake-flame" cx="120" cy="38" rx="7" ry="11" fill="url(#flameGrad)"/>
                    <path class="cake-flame-core" d="M120 31 C123 36 123 42 120 46 C117 42 117 36 120 31 Z" fill="#fff6b0"/>
                  </g>
                </svg>
              </div>

              <svg class="cumple-wave" viewBox="0 0 520 28" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,18 C80,28 140,4 260,14 C380,24 440,6 520,16 L520,28 L0,28 Z" fill="#ffffff"/>
              </svg>
            </div>

            <div class="cumple-copy">
              <p class="cumple-eyebrow">Hoy celebramos</p>
              <p class="cumple-greeting">¡Feliz cumpleaños a</p>
              <p class="cumple-name">{{ cumple.nombre_completo }}!</p>
              <span class="cumple-depto-chip">
                <v-icon x-small class="mr-1">mdi-office-building-outline</v-icon>
                {{ cumple.departamento }}
              </span>
              <p class="cumple-msg">
                Espero que este día esté lleno de alegría, risas y momentos especiales {{ cumplePronombre }} de tus seres queridos
              </p>
              <p class="cumple-msg cumple-msg--last">
                Que cumplas muchos años más llenos de salud y mucho éxito! 🥳🎂
              </p>
            </div>
          </div>
        </v-card-text>
        <v-btn
          class="cumple-close"
          icon
          small
          @click="dialogCumple = false"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- DIALOGO DE RECONOCIMIENTO (Moisés — solo 2026-08-17) -->
    <v-dialog
      v-model="dialogReconocimiento"
      max-width="540px"
      content-class="recon-dialog"
      transition="dialog-transition"
    >
      <v-card class="recon-card" elevation="0">
        <v-card-text class="black--text pa-0">
          <div class="recon-modal">
            <div class="recon-stage">
              <span class="recon-orb recon-orb--1"></span>
              <span class="recon-orb recon-orb--2"></span>
              <span class="recon-orb recon-orb--3"></span>
              <span class="recon-sparkle s1"></span>
              <span class="recon-sparkle s2"></span>
              <span class="recon-sparkle s3"></span>
              <span class="recon-sparkle s4"></span>
              <div class="recon-glow"></div>

              <div class="recon-fiesta" aria-hidden="true">
                <span class="recon-confetti c1"></span>
                <span class="recon-confetti c2"></span>
                <span class="recon-confetti c3"></span>
                <span class="recon-confetti c4"></span>
                <span class="recon-confetti c5"></span>
                <span class="recon-balloon b1"></span>
                <span class="recon-balloon b2"></span>
                <span class="recon-balloon b3"></span>
              </div>

              <div class="recon-star" aria-hidden="true">
                <svg class="recon-star-svg" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="reconStarGold" x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stop-color="#fff6d0"/>
                      <stop offset="45%" stop-color="#F5C518"/>
                      <stop offset="100%" stop-color="#C9A227"/>
                    </linearGradient>
                  </defs>
                  <circle cx="60" cy="60" r="38" fill="#fff" opacity="0.35"/>
                  <path
                    fill="url(#reconStarGold)"
                    d="M60 18 L70.5 46.5 L101 48 L77.5 67 L85 97 L60 81 L35 97 L42.5 67 L19 48 L49.5 46.5 Z"
                  />
                </svg>
              </div>

              <svg class="recon-wave" viewBox="0 0 520 28" preserveAspectRatio="none" aria-hidden="true">
                <path d="M0,18 C80,28 140,4 260,14 C380,24 440,6 520,16 L520,28 L0,28 Z" fill="#ffffff"/>
              </svg>
            </div>

            <div class="recon-copy">
              <p class="recon-eyebrow">Hoy celebramos</p>
              <p class="recon-greeting">¡Felicidades, Moisés!</p>
              <span class="recon-chip">
                <v-icon x-small class="mr-1">mdi-star-outline</v-icon>
                INBI
              </span>
              <p class="recon-msg">
                Un nuevo miembro del equipo de INBI logró obtener su bono de ventas a solo días de haberse incorporado, gracias a su esfuerzo, compromiso y actitud desde el inicio.
                Reconocemos este logro con orgullo, agradecemos su entusiasmo y el valor que aporta al equipo, y tenemos confianza en que seguirá alcanzando nuevas metas dentro de la empresa.
              </p>
            </div>

            <div class="recon-copy recon-copy--fast">
              <p class="recon-greeting">¡Felicidades, Claudia!</p>
              <span class="recon-chip recon-chip--fast">
                <v-icon x-small class="mr-1">mdi-star-outline</v-icon>
                FAST
              </span>
              <p class="recon-msg">
                Claudia Melisa Polina sigue destacando en Fast English. Alcanzó el bono del fin de semana de ventas, la confirmación de una racha imparable. Además, el plantel que lidera conquista el 🏆PRIMER LUGAR EN RETENCIÓN DE ALUMNOS🏆, cumpliendo la meta establecida. Números en la cima, liderazgo que se nota y resultados que no dejan lugar a dudas. Claudia Melisa está marcando la diferencia, ¡y esto apenas comienza!
              </p>
            </div>

          </div>
        </v-card-text>
        <v-btn
          class="recon-close"
          icon
          small
          @click="dialogReconocimiento = false"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- DIALOGO DE NUEVO PASSWORD -->
    <v-dialog
      v-model="dialogNewPass"
      max-width="350px"
      persistent
      transition="dialog-transition"
    >

      <v-card>
        <v-card-title class="text-h5">
          Actualiza tu contraseña
        </v-card-title>
        <v-card-text>
          <label>Debes ingresar una contraseña con al menos 8 caracteres</label>
          <v-text-field
            label="Nueva contraseña"
            rounded
            filled
            v-model="newPass"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            outlined
            @click="enviarNewPass"
            :loading="cargar"
            :disabled="cargar || !newPass || newPass.length < 8"
          >
            Actualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogoCorreoRecuperacion />

    <v-dialog
      v-model="dialogoPagosRechazados"
      max-width="1280px"
      scrollable
    >
      <v-card class="pagos-rechazados-card shadowCard">

        <v-card-title class="pagos-rechazados-header py-4 px-5">
          <v-icon color="error" class="mr-3" large>mdi-cash-register</v-icon>
          <div>
            <div class="text-h6 font-weight-bold mb-0">Pagos Rechazados</div>
            <div class="text-caption grey--text text--darken-1">
              Clic en una fila para ir a validar pagos
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-chip small color="error" text-color="white" class="mr-2">
            {{ pagosRechazados.length }} total
          </v-chip>
          <v-btn icon @click="dialogoPagosRechazados = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="px-5 py-4">

          <v-row dense class="mb-4">
            <v-col cols="12" sm="4">
              <v-sheet class="pagos-rechazados-stat pa-3" rounded outlined>
                <div class="text-caption grey--text">Registros visibles</div>
                <div class="text-h6 font-weight-bold">{{ pagosRechazadosFiltrados.length }}</div>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="4">
              <v-sheet class="pagos-rechazados-stat pa-3" rounded outlined>
                <div class="text-caption grey--text">Sucursal con más rechazos</div>
                <div class="text-subtitle-2 font-weight-bold text-truncate" :title="resumenPlantelesPagosRechazados.mas.plantel">
                  {{ resumenPlantelesPagosRechazados.mas.plantel }}
                </div>
                <div class="text-caption error--text font-weight-medium">{{ resumenPlantelesPagosRechazados.mas.total }} pagos</div>
              </v-sheet>
            </v-col>
            <v-col cols="12" sm="4">
              <v-sheet class="pagos-rechazados-stat pa-3" rounded outlined>
                <div class="text-caption grey--text">Sucursal con menos rechazos</div>
                <div class="text-subtitle-2 font-weight-bold text-truncate" :title="resumenPlantelesPagosRechazados.menos.plantel">
                  {{ resumenPlantelesPagosRechazados.menos.plantel }}
                </div>
                <div class="text-caption primary--text font-weight-medium">{{ resumenPlantelesPagosRechazados.menos.total }} pagos</div>
              </v-sheet>
            </v-col>
          </v-row>

          <v-sheet class="pa-3 mb-4 pagos-rechazados-filtros" rounded outlined>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-select
                  v-model="filtroPlantel"
                  :items="plantelesUnicos"
                  label="Plantel"
                  clearable
                  filled
                  dense
                  hide-details
                  prepend-inner-icon="mdi-store"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filtroFechaInicioPagos"
                  label="Fecha desde"
                  type="date"
                  filled
                  dense
                  hide-details
                  clearable
                  prepend-inner-icon="mdi-calendar-start"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filtroFechaFinPagos"
                  label="Fecha hasta"
                  type="date"
                  filled
                  dense
                  hide-details
                  clearable
                  prepend-inner-icon="mdi-calendar-end"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filtroTextoPagosRechazados"
                  label="Buscar"
                  placeholder="Alumno, motivo, monto..."
                  prepend-inner-icon="mdi-magnify"
                  filled
                  dense
                  hide-details
                  clearable
                />
              </v-col>
            </v-row>
          </v-sheet>

          <v-data-table
            :headers="headersPagosRechazados"
            :items="pagosRechazadosFiltrados"
            class="pagos-rechazados-table elevation-0"
            dense
            fixed-header
            height="420"
            :loading="cargarPagosRechazadosLista"
            loading-text="Cargando pagos rechazados..."
            :items-per-page="15"
            :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, -1] }"
            @click:row="irAValidarPagos"
          >
            <template v-slot:item.fecha_pago="{ item }">
              <span class="text-caption">{{ formatoFechaPago( item.fecha_pago ) }}</span>
            </template>

            <template v-slot:item.monto_pagado="{ item }">
              <span class="font-weight-bold error--text">{{ formatoMonedaPagos( item.monto_pagado ) }}</span>
            </template>

            <template v-slot:item.plantel_alumno="{ item }">
              <v-chip x-small label outlined color="primary">{{ item.plantel_alumno || item.plantel || '—' }}</v-chip>
            </template>

            <template v-slot:item.motivo_rechazo="{ item }">
              <v-tooltip bottom max-width="320">
                <template v-slot:activator="{ on, attrs }">
                  <span class="pagos-rechazados-motivo text-caption" v-bind="attrs" v-on="on">
                    {{ item.motivo_rechazo }}
                  </span>
                </template>
                <span>{{ item.motivo_rechazo }}</span>
              </v-tooltip>
            </template>

            <template v-slot:item.usuario_ingreso="{ item }">
              <span class="text-caption">{{ item.usuario_ingreso || '—' }}</span>
            </template>
          </v-data-table>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-5 py-3">
          <span class="text-caption grey--text">
            Mostrando {{ pagosRechazadosFiltrados.length }} de {{ pagosRechazados.length }} pagos rechazados
          </span>
          <v-spacer></v-spacer>
          <v-btn color="primary" depressed @click="dialogoPagosRechazados = false">
            Cerrar
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>


    <notifications group="foo" position="top right" width="360">
      <template slot="body" slot-scope="props">
        <div
          :class="[
            'vue-notification-template',
            props.item.type,
            {
              'notification-clickable': props.item.data && props.item.data.accion === 'examen-ubicacion',
              'notification-examen-ubicacion': props.item.data && props.item.data.accion === 'examen-ubicacion'
            }
          ]"
          @click="onKpiNotifyClick(props.item, () => props.close())"
        >
          <div
            v-if="props.item.title"
            class="notification-title"
            v-html="props.item.title"
          />
          <div
            class="notification-content"
            v-html="props.item.text"
          />
        </div>
      </template>
    </notifications>

    <DirectorioGeneral
      :dialogDirectorio="dialogDirectorio"
      v-if="dialogDirectorio.estatus"
    />

    <BugReportDialog
      v-model="bugReportDialog"
      :context="bugReportContext"
    />
  </v-app>
</template>

<script>
  import { mapGetters, mapActions }    from "vuex";
  import { Device } from '@capacitor/device';       // Angel Rodríguez

  var moment              = require('moment');

  import CARRITO          from '@/components/Carrito.vue'
  import BITACORA         from '@/components/BITACORA.vue'


  import metodos          from '@/mixins/metodos.js';
  import validarErrores   from '@/mixins/validarErrores'
  import mixinApp         from '@/mixins/mixinApp'
  import mixinReporteApp  from '@/mixins/mixinReporteApp'
  import mixinEstatusWha  from '@/mixins/mixinEstatusWha'

  import * as sessionIdle from '@/utils/sessionIdle'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
  import Calendario            from '@/components/Calendario.vue';

  import MisComisiones         from '@/components/nomina/MisComisiones.vue'
  import MisTickets            from '@/components/tickets/MisTickets.vue'

  import AlertaSeguimiento     from '@/components/alertas/AlertaSeguimiento.vue';
  import NuevoProspecto        from '@/components/prospectos/NuevoProspecto.vue';

  import FaltaraTeacher        from '@/components/alertas/FaltaraTeacher.vue';
  import NuevaVenta            from '@/components/alertas/NuevaVenta.vue';
  import NuevaRI                from '@/components/alertas/NuevaRI.vue';
  import dialogNotificacion    from '@/components/alertas/dialogNotificacion.vue';
  import SinSeguimiento        from '@/components/alertas/SinSeguimiento.vue';
  import newPassword           from '@/components/alertas/newPassword.vue';
  import DialogoCorreoRecuperacion from '@/components/DialogoCorreoRecuperacion.vue'
  import DirectorioGeneral     from '@/views/catalogos/DirectorioGeneral'
  import AlertaEquipoUso       from '@/components/alertas/AlertaEquipoUso.vue';
  import AlertaAccesoBloqueado from '@/components/alertas/AlertaAccesoBloqueado.vue';
  import BugReportDialog       from '@/components/bug-reports/BugReportDialog.vue';
  import DiagnosticoSistemaAppBar from '@/components/diagnostico/DiagnosticoSistemaAppBar.vue'
  import PruebaWhatsappRendimientoAppBar from '@/components/diagnostico/PruebaWhatsappRendimientoAppBar.vue';
  import EncuestaTwilioModal from '@/components/encuesta/EncuestaTwilioModal.vue';
  import EstatusRecepcionSidebar from '@/components/kpi/EstatusRecepcionSidebar.vue';
  import {
    ENCUESTA_TWILIO_EVENT,
    aplicaEncuestaTwilio,
    encuestaTwilioBus,
  } from '@/utils/encuestaTwilio';
  import {
    ACCESO_BLOQUEADO_EVENT,
    ACCESO_BLOQUEADO_ACTIVO_EVENT,
    accesoBloqueadoBus,
  } from '@/utils/accesoBloqueado';
  import { BUG_REPORT_EVENT_NAME, buildManualBugContext } from '@/utils/bugReporter'
  import { esExcepcionTwilioOnline } from '@/config/twilioUsuariosOnline'
  import appVersion from '@/config/appVersion'
  import { etiquetaAmbiente } from '@/config/appEnv'
  import { esVendedoraRanking } from '@/utils/estatusVendedoraRanking'
  import { asegurarMenuEgresosComprobantes } from '@/utils/permisosEgresosComprobantes'
  import { asegurarMenuNaomiPalma } from '@/utils/permisosNaomiMenu'
  import { asegurarMenuControlEquipos } from '@/utils/permisosControlEquipos'
  import { aplicarRestriccionMenuPorUsuario } from '@/utils/permisosRestriccionUsuario'
  import {
    asegurarMenuDireccionesEmpleados,
    esAccesoDireccionesEmpleados,
  } from '@/utils/permisosDireccionesEmpleados'
  import { asegurarMenuAsistenciaAlumnos } from '@/utils/permisosAsistenciaAlumnos'
  import { puedeVerMenuNominaColaboradores } from '@/utils/nominaColaboradoresPermisos'
  import { esPuestoCalidad, menuSoloCalidad } from '@/utils/puestoCalidad'
  import {
    BLOQUEO_VALIDACION_FINANZAS_EVENT,
    RUTA_DEFAULT_BLOQUEO_FINANZAS,
    bloqueoValidacionFinanzasBus,
    esUsuarioAdminFinanzas,
    filtrarMenuBloqueoValidacionFinanzas,
    getEstadoBloqueoValidacionFinanzas,
    setEstadoBloqueoValidacionFinanzas,
  } from '@/utils/bloqueoValidacionFinanzas'

  var QRCode = require('qrcode')

  export default {
    mixins:[ metodos, mixinApp, validarErrores, mixinEstatusWha, mixinReporteApp ],

    name: "App",

    components:{
      BITACORA,
      CARRITO,
      Alerta,
      carga,
      AlertaSeguimiento,
      NuevoProspecto,
      FaltaraTeacher,
      NuevaVenta,
      NuevaRI,
      dialogNotificacion,
      Calendario,
      MisComisiones,
      MisTickets,
      SinSeguimiento,
      newPassword,
      DialogoCorreoRecuperacion,
      DirectorioGeneral,
      AlertaEquipoUso,
      AlertaAccesoBloqueado,
      BugReportDialog,
      DiagnosticoSistemaAppBar,
      PruebaWhatsappRendimientoAppBar,
      EncuestaTwilioModal,
      EstatusRecepcionSidebar
    },

    data: () => ({
      appVersion: appVersion,
      etiquetaAmbiente,

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      alertaAccesoBloqueado: {
        estatus: false,
        motivo: '',
      },
      intervaloAccesoBloqueado: null,

      bloqueoValidacionFinanzas: {
        pendientes: 0,
        desbloqueo_emergencia: false,
        bloqueado: false,
        cargado: false,
      },
      intervaloBloqueoValidacionFinanzas: null,

      radio:1,
      drawer: true,
      drawer2:false,
      mini:false,
      menu: [],
      menuTienda:[],
      active:false,
      ciaws:'',
      logo:'',
      menuTicket:[],
      avatar:'',
      // descripClima:'',
      // temperatura: 0,
      // iconClima:'',
      estatusLlamada: false,

      escuela: null,

      carrito_activo: false,
      tareas_activas: false,

      newPass:'',

      permisos:[],
      fab:null,
      search:'',
      menuBusqueda:[],
      estatusWhats:false,
      abrirDialogWhatsApp:false,

      encuestaTwilio: {
        abierta: false,
        verificada: false,
      },

      deviceInfo: {},  //Angel Rodriguez
      batteryInfo: {},  //Angel Rodriguez

      timeAlerta: null,
      alertaSeguimiento:{
        estatus: false,
      },

      abrirDialogProspecto:{
        estatus: false
      },

      dialogNotifica: {
        estatus: false,
        notificacion: null
      },

      dialogCalendario:{
        estatus: false
      },

      actividadesHoy: 0,
      calendario: [],
      disponibilidad_completa: 1,

      paramsComisiones:{
        estatus: false
      },

      paramsTickets:{
        estatus: false
      },

      cumple: null,
      dialogCumple: false,
      cumpleMinuto07Timer: null,
      cumpleRecuperadoSesion: false,
      // Fecha local (YYYY-MM-DD) para la que se cargó el festejo; evita mostrar ayer tras medianoche
      cumpleFechaSesion: null,
      dialogReconocimiento: false,
      reconocimientoTimer: null,
      reconocimientoHoraLista: false,
      reconocimientoCerradoEstaSesion: false,

      menubitacora:{
        estatus: false
      },

      autor: '',
      frase: '',
      dialogNewPass: false,

      dialogDirectorio:{
        estatus: false
      },

      dialogoPagosRechazados: false,
      headersPagosRechazados: [
        { text: 'Id', value: 'id_ingreso', width: '72px' },
        { text: 'Fecha', value: 'fecha_pago', width: '130px' },
        { text: 'Monto', value: 'monto_pagado', width: '110px', align: 'end' },
        { text: 'Alumno', value: 'nombre_alumno' },
        { text: 'Plantel', value: 'plantel_alumno', width: '140px' },
        { text: 'Motivo rechazo', value: 'motivo_rechazo' },
        { text: 'Ingresó', value: 'usuario_ingreso', width: '160px' },
      ],
      pagosRechazados: [],
      filtroPlantel: null,
      filtroFechaInicioPagos: '',
      filtroFechaFinPagos: '',
      filtroTextoPagosRechazados: '',
      cargarPagosRechazadosLista: false,
      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      bugReportDialog: false,
      bugReportContext: {},

      novedadesHoy: { count: 0 },
      novedadesVistasHoy: false,
      novedadesHoyTimer: null,
      intervaloEstatusRecepcion: null,

    }),

    watch: {

      getEstatusLlamada (val) {
        this.estatusLlamada = val
      },

      dialogReconocimiento(val) {
        if (val) {
          if (!this.esAdminReconocimientoSiempre) {
            this.marcarReconocimientoMoises()
          }
          return
        }
        if (this.esAdminReconocimientoSiempre) {
          this.reconocimientoCerradoEstaSesion = true
        }
        if (!this.getLogeado || !this.esReconocimientoMoisesHoy) return
        if (this.hayCumpleHoy) {
          this.dialogCumple = true
        }
      },
      /*
      getdatosUsuarioERPERP () {
        this.getPermisos()
      },*/
      getdatosUsuarioERPERP: {
        immediate: true,
        async handler(usuario) {
          if (usuario) {

            await this.verificarAccesoBloqueado()
            if (this.alertaAccesoBloqueado.estatus) {
              return
            }

            if (aplicaEncuestaTwilio(usuario)) {
              await this.verificarEncuestaTwilio();
              if (this.encuestaTwilio.abierta) {
                this.iniciarWatchReconocimiento()
                return;
              }
            }

            await this.getPermisos( )

            await this.getNotificaciones( )

            await this.getCalendario( )

            // Bloquear todo
            if( !usuario.updatePassword && usuario.iderp != 1 ){

              this.dialogNewPass = true

            }

            await this.inicializarApp(usuario)

            this.consultarNovedadesHoyDeferred()

            // Validación para el inge y abi
            if( [954,28,966,32,334,2230,718].includes( usuario.iderp ) ){
              // Validar si hay requisiciones sin validar del día de ayer
              // await this.validarRequisPendientes( )
              await this.validarObjetivosSemanales( )
            }

          } else {
            this.limpiarApp();
          }
        }
      },

      getLogeado: {
        immediate: true,
        handler(loggedIn) {
          if (loggedIn) {
            this.$nextTick(() => this.bindSessionIdle());
          } else {
            sessionIdle.stop();
            this.encuestaTwilio.abierta = false;
            this.encuestaTwilio.verificada = false;
          }
        },
      },

      search( val ){
        if( val ){ this.$router.push({ name: val }) }
      },

      '$route.name'(name) {
        if (name === 'TimelineCambios') {
          this.marcarNovedadesVistasHoy()
        }
      },


    },

    async created(){

      await this.getTareasProgramadasFormulario()

      // await this.initReloj()

      // await this.getPermisos()

      // await this.getNotificaciones();

      // await this.getCalendario()

      this.nuevosProspectos();

      
      if( this.getdatosUsuarioERPERP ){
        // quienCumpleAnios solo en inicializarApp (watch immediate) para evitar doble disparo
        this.avatar  = "https://ui-avatars.com/api/?background=1976d2&color=fff&rounded=true&format=svg&name=" + this.getdatosUsuarioERPERP.nombre_completo + this.getdatosUsuarioERPERP.apellido;

        if( [0,1,2,3,4,5,6,21,17,22,23,24,25,26,27,28,29,30,31,32,33,34].includes( this.getdatosUsuarioERPERP.id_plantel ) || this.getdatosUsuarioERPERP.id_plantel > 100 ){
          this.cambiarEscuela(1)
          this.$vuetify.theme.themes.light.primary    = '#44A7FF'
          this.$vuetify.theme.themes.light.secondary  = '#D25AF3'
        }else{
          this.cambiarEscuela(2)
          this.$vuetify.theme.themes.light.secondary = '#AF0010'
          this.$vuetify.theme.themes.light.primary   = '#000B58'
        }

        if( [1794].includes( this.getdatosUsuarioERPERP.iderp ) ){
          this.cambiarEscuela(1)
          this.$vuetify.theme.themes.light.primary    = '#44A7FF'
          this.$vuetify.theme.themes.light.secondary  = '#D25AF3'
        }
      }

      this.escuela = this.getEscuela

      this.getComisionesVendedora( )
      this.getTicketsPorUsuario( )

    },

    mounted(){
      window.addEventListener(BUG_REPORT_EVENT_NAME, this.onBugReportEvent)
      encuestaTwilioBus.$on(ENCUESTA_TWILIO_EVENT, this.onEncuestaTwilioPendiente)
      accesoBloqueadoBus.$on(ACCESO_BLOQUEADO_EVENT, this.onAccesoBloqueadoActualizar)
      accesoBloqueadoBus.$on(ACCESO_BLOQUEADO_ACTIVO_EVENT, this.aplicarEstadoAccesoBloqueado)
      bloqueoValidacionFinanzasBus.$on(BLOQUEO_VALIDACION_FINANZAS_EVENT, this.onBloqueoValidacionFinanzas)
      this.$root.$on('timeline-novedades-actualizado', this.consultarNovedadesHoyDeferred)
      if (this.$route.name === 'TimelineCambios') {
        this.marcarNovedadesVistasHoy()
      }
    },

    beforeDestroy(){
      window.removeEventListener(BUG_REPORT_EVENT_NAME, this.onBugReportEvent)
      encuestaTwilioBus.$off(ENCUESTA_TWILIO_EVENT, this.onEncuestaTwilioPendiente)
      accesoBloqueadoBus.$off(ACCESO_BLOQUEADO_EVENT, this.onAccesoBloqueadoActualizar)
      accesoBloqueadoBus.$off(ACCESO_BLOQUEADO_ACTIVO_EVENT, this.aplicarEstadoAccesoBloqueado)
      bloqueoValidacionFinanzasBus.$off(BLOQUEO_VALIDACION_FINANZAS_EVENT, this.onBloqueoValidacionFinanzas)
      this.$root.$off('timeline-novedades-actualizado', this.consultarNovedadesHoyDeferred)
      if (this.novedadesHoyTimer) {
        clearTimeout(this.novedadesHoyTimer)
        this.novedadesHoyTimer = null
      }
      this.detenerWatchCumpleMinuto07()
      this.detenerPollEstatusRecepcion();
      this.detenerPollAccesoBloqueado();
      this.detenerPollBloqueoValidacionFinanzas();
      this.detenerWatchReconocimiento();
    },

    methods:{
      ...mapActions('login', ['salirLogin','cambiarEscuela','abrirProspecto','cambiarEstatusLlamada','addTareas','traerProspectosNuevos','addPermisos','marcarReconocimientoMoises']),

      abrirBugReport(){
        this.bugReportContext = buildManualBugContext({
          store: this.$store,
          router: this.$router,
        })
        this.bugReportDialog = true
      },

      onBugReportEvent(event){
        this.bugReportContext = event && event.detail ? event.detail : {}
        this.bugReportDialog = true
      },

      async verificarEncuestaTwilio() {
        const usuario = this.getdatosUsuarioERPERP;
        if (!this.getLogeado || !usuario || !aplicaEncuestaTwilio(usuario)) {
          this.encuestaTwilio.abierta = false;
          this.encuestaTwilio.verificada = true;
          return;
        }

        try {
          const response = await this.$http.get('encuesta-twilio.estado');
          const data = response.data || {};
          this.encuestaTwilio.verificada = true;
          this.encuestaTwilio.abierta = !!data.pendiente;
        } catch (error) {
          console.warn('[encuesta-twilio] estado', error);
        }
      },

      onEncuestaTwilioPendiente(mensaje) {
        const usuario = this.getdatosUsuarioERPERP;
        if (!usuario || !aplicaEncuestaTwilio(usuario)) return;
        this.encuestaTwilio.abierta = true;
        if (mensaje) {
          this.validarErrorDirecto(mensaje);
        }
      },

      onEncuestaTwilioRespondida() {
        this.encuestaTwilio.abierta = false;
        this.encuestaTwilio.verificada = true;
        const usuario = this.getdatosUsuarioERPERP;
        if (usuario) {
          this.getPermisos();
          this.getNotificaciones();
          this.getCalendario();
          this.inicializarApp(usuario);
          this.consultarNovedadesHoyDeferred();
        }
      },

      onAccesoBloqueadoActualizar(mensaje) {
        this.respuestaAlerta = true;
        this.parametros.color = 'error';
        this.parametros.mensaje = mensaje || 'Acceso denegado, Favor de actualizar su plataforma';
        // Forzar reabrir si ya estaba abierto / lo quitaron del DOM
        this.parametros.dialogError = false;
        this.$nextTick(() => {
          this.parametros.dialogError = true;
        });
      },

      aplicarEstadoAccesoBloqueado(payload) {
        const estabaBloqueado = this.alertaAccesoBloqueado.estatus;
        const esObj = payload && typeof payload === 'object';
        const valor = esObj ? payload.bloqueado : payload;
        const motivo = esObj ? (payload.motivo || '') : (this.alertaAccesoBloqueado.motivo || '');
        const activo = Number(valor) === 1;
        this.alertaAccesoBloqueado.estatus = activo;
        this.alertaAccesoBloqueado.motivo = activo ? motivo : '';
        if (activo) {
          this.iniciarPollAccesoBloqueado();
        } else {
          this.detenerPollAccesoBloqueado();
          if (estabaBloqueado && this.getdatosUsuarioERPERP) {
            this.inicializarApp(this.getdatosUsuarioERPERP);
          }
        }
      },

      async verificarAccesoBloqueado() {
        if (!this.getLogeado || !this.getdatosUsuarioERPERP) return;
        try {
          const response = await this.$http.get('sistemas.bloqueo.mi-estado');
          const data = response.data || {};
          this.aplicarEstadoAccesoBloqueado({
            bloqueado: data.bloqueado,
            motivo: data.motivo || '',
          });
        } catch (error) {
          // Silencioso: no interrumpir arranque si falla la consulta
        }
      },

      onBloqueoValidacionFinanzas(estado) {
        this.bloqueoValidacionFinanzas = Object.assign({}, this.bloqueoValidacionFinanzas, estado || {})
      },

      async verificarBloqueoValidacionFinanzas() {
        const usuario = this.getdatosUsuarioERPERP
        if (!this.getLogeado || !usuario || !esUsuarioAdminFinanzas(usuario.iderp)) {
          this.detenerPollBloqueoValidacionFinanzas()
          setEstadoBloqueoValidacionFinanzas({
            pendientes: 0,
            desbloqueo_emergencia: false,
            bloqueado: false,
          })
          this.bloqueoValidacionFinanzas = getEstadoBloqueoValidacionFinanzas()
          return getEstadoBloqueoValidacionFinanzas()
        }

        try {
          const response = await this.$http.get('finanzas.bloqueo-validacion.estado')
          const data = response.data || {}
          const estado = setEstadoBloqueoValidacionFinanzas({
            pendientes: Number(data.pendientes) || 0,
            desbloqueo_emergencia: !!data.desbloqueo_emergencia,
            bloqueado: !!data.bloqueado,
          })
          this.bloqueoValidacionFinanzas = estado
          this.iniciarPollBloqueoValidacionFinanzas()
          return estado
        } catch (error) {
          return this.bloqueoValidacionFinanzas
        }
      },

      iniciarPollBloqueoValidacionFinanzas() {
        this.detenerPollBloqueoValidacionFinanzas()
        if (!esUsuarioAdminFinanzas(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)) {
          return
        }
        this.intervaloBloqueoValidacionFinanzas = setInterval(() => {
          const antes = !!(this.bloqueoValidacionFinanzas && this.bloqueoValidacionFinanzas.bloqueado)
          this.verificarBloqueoValidacionFinanzas().then((estado) => {
            const ahora = !!(estado && estado.bloqueado)
            if (antes !== ahora) {
              this.getPermisos()
            }
          })
        }, 30000)
      },

      detenerPollBloqueoValidacionFinanzas() {
        if (this.intervaloBloqueoValidacionFinanzas) {
          clearInterval(this.intervaloBloqueoValidacionFinanzas)
          this.intervaloBloqueoValidacionFinanzas = null
        }
      },

      iniciarPollAccesoBloqueado() {
        this.detenerPollAccesoBloqueado();
        this.intervaloAccesoBloqueado = setInterval(() => {
          this.verificarAccesoBloqueado();
        }, 10000);
      },

      detenerPollAccesoBloqueado() {
        if (this.intervaloAccesoBloqueado) {
          clearInterval(this.intervaloAccesoBloqueado);
          this.intervaloAccesoBloqueado = null;
        }
      },

      async inicializarApp(usuario) {
        await this.verificarAccesoBloqueado();
        if (this.alertaAccesoBloqueado.estatus) {
          this.avatar = "https://ui-avatars.com/api/?background=1976d2&color=fff&rounded=true&format=svg&name=" + usuario.nombre_completo + usuario.apellido;
          return;
        }

        const estadoFinanzas = await this.verificarBloqueoValidacionFinanzas()

        const results = await Promise.allSettled([
          this.getTareasProgramadasFormulario(),
          this.getPermisos(),
          this.getNotificaciones(),
          this.getCalendario(),
          this.quienCumpleAnios(),
          this.getTicketsPorUsuario(),
          this.getComisionesVendedora(),
        ]);

        if (
          estadoFinanzas &&
          estadoFinanzas.bloqueado &&
          this.$route &&
          this.$route.name &&
          this.$route.name !== RUTA_DEFAULT_BLOQUEO_FINANZAS &&
          ![
            'CorteDiario',
            'ValidarPagos',
            'ValidarIngresos',
            'EstadoCuentasBanco',
            'EstadoCuentasBancoDetalles',
            'Login',
            'Perfil',
          ].includes(this.$route.name)
        ) {
          this.$router.replace({ name: RUTA_DEFAULT_BLOQUEO_FINANZAS }).catch(() => {})
        }

        this.iniciarWatchReconocimiento()

        this.nuevosProspectos();


        this.avatar = "https://ui-avatars.com/api/?background=1976d2&color=fff&rounded=true&format=svg&name=" + usuario.nombre_completo + usuario.apellido;


        if ([0,1,2,3,4,5,6,21,17,22,23,24,25,26,27,28,29,30,31,32,33,34].includes(usuario.id_plantel) || usuario.id_plantel > 100) {
          this.cambiarEscuela(1);
          this.$vuetify.theme.themes.light.primary   = '#44A7FF';
          this.$vuetify.theme.themes.light.secondary = '#D25AF3';
        } else {
          this.cambiarEscuela(2);
          this.$vuetify.theme.themes.light.primary   = '#000B58';
          this.$vuetify.theme.themes.light.secondary = '#AF0010';
        }

        this.escuela = this.getEscuela;

        this.iniciarPollEstatusRecepcion();

      },

      notificacionTest() {
        this.alertaNuevaVenta.mensaje = { mensaje: 'Este es un mensaje de pruebas' }
        this.alertaNuevaVenta.type    = 'success'
        this.alertaNuevaVenta.estatus = true

      },

      limpiarApp() {
        this.menu = [];
        this.addPermisos([]);
        this.cumple = null;
        this.dialogCumple = false;
        this.dialogReconocimiento = false;
        this.reconocimientoHoraLista = false;
        this.reconocimientoCerradoEstaSesion = false;
        this.detenerWatchReconocimiento();
        this.avatar = null;
        this.calendario = [];
        this.actividadesHoy = 0;
        this.menuBusqueda = [];
        this.carrito_activo = false;
        this.tareas_activas = false;
        this.novedadesHoy = { count: 0 };
        this.novedadesVistasHoy = false;
        if (this.novedadesHoyTimer) {
          clearTimeout(this.novedadesHoyTimer)
          this.novedadesHoyTimer = null
        }
        this.detenerWatchCumpleMinuto07()
        this.cumpleRecuperadoSesion = false
        this.cumpleFechaSesion = null
        this.detenerPollEstatusRecepcion();
        this.detenerPollAccesoBloqueado();
        this.detenerPollBloqueoValidacionFinanzas();
        this.alertaAccesoBloqueado.estatus = false;
        this.alertaAccesoBloqueado.motivo = '';
        setEstadoBloqueoValidacionFinanzas({
          pendientes: 0,
          desbloqueo_emergencia: false,
          bloqueado: false,
        })
        this.bloqueoValidacionFinanzas = getEstadoBloqueoValidacionFinanzas()
      },

      iniciarPollEstatusRecepcion() {
        this.detenerPollEstatusRecepcion();
        const usuario = this.getdatosUsuarioERPERP;
        if (!usuario || !esVendedoraRanking(usuario.idpuesto)) return;
        this.$store.dispatch('login/cargarEstatusRecepcionMap');
        this.intervaloEstatusRecepcion = setInterval(() => {
          this.$store.dispatch('login/cargarEstatusRecepcionMap');
        }, 30000);
      },

      detenerPollEstatusRecepcion() {
        if (this.intervaloEstatusRecepcion) {
          clearInterval(this.intervaloEstatusRecepcion);
          this.intervaloEstatusRecepcion = null;
        }
      },

      getFechaHoyLocal() {
        return (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      },

      initNovedadesVistasHoy() {
        try {
          this.novedadesVistasHoy = localStorage.getItem('timeline_novedades_visto') === this.getFechaHoyLocal()
        } catch (e) {
          this.novedadesVistasHoy = false
        }
      },

      marcarNovedadesVistasHoy() {
        try {
          localStorage.setItem('timeline_novedades_visto', this.getFechaHoyLocal())
        } catch (e) { /* ignore */ }
        this.novedadesVistasHoy = true
      },

      consultarNovedadesHoyDeferred() {
        if (this.novedadesHoyTimer) {
          clearTimeout(this.novedadesHoyTimer)
        }
        this.novedadesHoyTimer = setTimeout(() => {
          this.novedadesHoyTimer = null
          this.consultarNovedadesHoy()
        }, 5000)
      },

      consultarNovedadesHoy() {
        if (!this.getdatosUsuarioERPERP) return Promise.resolve()
        return this.$http.get('timeline-sistema.hoy')
          .then((response) => {
            const data = response.data || {}
            this.novedadesHoy = { count: Number(data.count) || 0 }
          })
          .catch(() => {})
          .finally(() => {
            this.initNovedadesVistasHoy()
          })
      },

      bindSessionIdle() {
        sessionIdle.stop();
        const minutes = sessionIdle.getIdleMinutesFromEnv();
        sessionIdle.start({
          timeoutMs: minutes * 60 * 1000,
          onIdle: () => {
            sessionIdle.stop();
            this.limpiarApp();
            this.salirLogin();
            this.$notify({
              group: 'foo',
              title: 'Sesión',
              text: 'Tu sesión se cerró por inactividad. Inicia sesión de nuevo.',
              type: 'warn',
              duration: 8000,
            });
            this.$router.replace({ name: 'Login', query: { reason: 'idle' } }).catch(() => {});
          },
        });
      },

      onDrawerToggle(val) {
        if (val) {
          this.$refs.bitacora.initialize();
          this.$refs.bitacora.getAlumnos();

        }
      },

      nuevosProspectos(){
        // Mostrar el contador solamente
        this.traerProspectosNuevos( this.getdatosUsuarioERPERP.iderp )
      },

      async quienCumpleAnios() {
        // Evitar solapamiento (TTL / medianoche / init)
        if (this._cumpleAniosCargando) return
        this._cumpleAniosCargando = true

        try {
        // Carga data del día; abre en horarios fijos o recupera 1 vista pendiente al entrar
        const fechaHoy = this.fechaLocalHoy()
        let cache = this.leerCacheCumple()

        // Cache de otro día: invalidar (no reutilizar cumpleaños de ayer)
        if (cache && cache.fecha !== fechaHoy) {
          this.purgarCumpleCaducado()
          cache = null
        }

        const mismoDia = !!(cache && cache.fecha === fechaHoy)
        const vistasPrevias = mismoDia && typeof cache.vistas === 'number' ? cache.vistas : 0
        const horariosPrevios = mismoDia && Array.isArray(cache.horariosMostrados)
          ? cache.horariosMostrados
          : []

        // Reconsultar API si no hay data de hoy o el cache tiene más de 30 min
        const ttlMs = 30 * 60 * 1000
        const consultadoEn = mismoDia && cache.consultadoEn ? Number(cache.consultadoEn) : 0
        const cacheFresco = consultadoEn > 0 && (Date.now() - consultadoEn) < ttlMs
        let data = mismoDia && cacheFresco && cache.data ? cache.data : null

        const guardar = (payload, vistas, horariosMostrados, consultado) => {
          const stamped = Object.assign({}, payload, { fechaCumple: fechaHoy })
          localStorage.setItem('quienCumpleAnios', JSON.stringify({
            fecha: fechaHoy,
            vistas: vistas || 0,
            horariosMostrados: horariosMostrados || [],
            consultadoEn: consultado || Date.now(),
            data: stamped
          }))
          return stamped
        }

        const fetchCumple = async () => {
          const response = await this.$http.get('cumple.anios', {
            params: { fecha: fechaHoy }
          })
          return this.resolverGeneroCumple(response.data || {})
        }

        if (!data) {
          try {
            data = await fetchCumple()
            // Al refrescar por TTL, conservar vistas/horarios del día
            data = guardar(data, vistasPrevias, horariosPrevios, Date.now())
          } catch (e) {
            return
          } finally {
            this.cargar = false
          }
        } else if (data.fechaCumple && data.fechaCumple !== fechaHoy) {
          this.purgarCumpleCaducado()
          try {
            data = await fetchCumple()
            data = guardar(data, 0, [], Date.now())
          } catch (e) {
            return
          } finally {
            this.cargar = false
          }
        } else {
          data = await this.resolverGeneroCumple(data)
          data = guardar(data, vistasPrevias, horariosPrevios, consultadoEn || Date.now())
        }

        this.cumple = data
        this.cumpleFechaSesion = fechaHoy
        this.iniciarWatchCumpleMinuto07()
        this.intentarMostrarCumple({ recuperacion: true })
        } finally {
          this._cumpleAniosCargando = false
        }
      },

      fechaLocalHoy() {
        const ahora = new Date()
        return [
          ahora.getFullYear(),
          String(ahora.getMonth() + 1).padStart(2, '0'),
          String(ahora.getDate()).padStart(2, '0')
        ].join('-')
      },

      leerCacheCumple() {
        try {
          return JSON.parse(localStorage.getItem('quienCumpleAnios'))
        } catch (e) {
          return null
        }
      },

      /** Borra cache y memoria si no pertenecen al día local actual. */
      purgarCumpleCaducado() {
        const fechaHoy = this.fechaLocalHoy()
        const cache = this.leerCacheCumple()
        if (cache && cache.fecha && cache.fecha !== fechaHoy) {
          try {
            localStorage.removeItem('quienCumpleAnios')
          } catch (e) { /* ignore */ }
        }
        const dataFecha = this.cumple && this.cumple.fechaCumple
        if (
          this.cumpleFechaSesion !== fechaHoy ||
          (dataFecha && dataFecha !== fechaHoy) ||
          (cache && cache.fecha && cache.fecha !== fechaHoy)
        ) {
          this.cumple = null
          this.dialogCumple = false
          this.cumpleRecuperadoSesion = false
          this.cumpleFechaSesion = null
        }
      },

      /** true solo si cache + payload son del día local de hoy. */
      cacheCumpleEsDeHoy() {
        const fechaHoy = this.fechaLocalHoy()
        const cache = this.leerCacheCumple()
        if (!cache || cache.fecha !== fechaHoy) return false
        if (cache.data && cache.data.fechaCumple && cache.data.fechaCumple !== fechaHoy) {
          return false
        }
        return true
      },

      // Horarios fijos del festejo (hora:minuto local)
      horariosCumpleFijos() {
        return [
          { key: '09:07', minutos: 9 * 60 + 7 },
          { key: '12:37', minutos: 12 * 60 + 37 },
          { key: '16:07', minutos: 16 * 60 + 7 }
        ]
      },

      horarioCumpleActual() {
        const ahora = new Date()
        const hh = String(ahora.getHours()).padStart(2, '0')
        const mm = String(ahora.getMinutes()).padStart(2, '0')
        return `${hh}:${mm}`
      },

      minutosAhora() {
        const ahora = new Date()
        return ahora.getHours() * 60 + ahora.getMinutes()
      },

      iniciarWatchCumpleMinuto07() {
        this.detenerWatchCumpleMinuto07()
        this.intentarMostrarCumple({ recuperacion: false })
        this.cumpleMinuto07Timer = setInterval(() => {
          const hoy = this.fechaLocalHoy()
          // Pestaña abierta tras medianoche: cerrar modal de ayer y recargar
          if (
            (this.cumpleFechaSesion && this.cumpleFechaSesion !== hoy) ||
            !this.cacheCumpleEsDeHoy()
          ) {
            this.dialogCumple = false
            this.purgarCumpleCaducado()
            this.quienCumpleAnios()
            return
          }
          // Reconsultar API si el cache del día ya tiene más de 30 min
          const cache = this.leerCacheCumple()
          const ttlMs = 30 * 60 * 1000
          const consultadoEn = cache && cache.consultadoEn ? Number(cache.consultadoEn) : 0
          if (!consultadoEn || (Date.now() - consultadoEn) >= ttlMs) {
            this.quienCumpleAnios()
            return
          }
          this.intentarMostrarCumple({ recuperacion: false })
        }, 15000)
      },

      detenerWatchCumpleMinuto07() {
        if (this.cumpleMinuto07Timer) {
          clearInterval(this.cumpleMinuto07Timer)
          this.cumpleMinuto07Timer = null
        }
      },

      intentarMostrarCumple({ recuperacion = false } = {}) {
        // Puesto Calidad: no mostrar alertas de cumpleaños
        if (this.esPuestoCalidadMenu) return

        const fechaHoy = this.fechaLocalHoy()

        // Si cambió el día con el modal abierto, cerrarlo de inmediato
        if (
          this.dialogCumple &&
          (
            (this.cumpleFechaSesion && this.cumpleFechaSesion !== fechaHoy) ||
            !this.cacheCumpleEsDeHoy()
          )
        ) {
          this.dialogCumple = false
          this.purgarCumpleCaducado()
          return
        }

        if (this.dialogCumple) return
        if (this.dialogReconocimiento) return
        if (this.esReconocimientoMoisesHoy && this.yaEsHoraReconocimiento() && !this.yaVioReconocimientoHoy()) return
        if (recuperacion && this.cumpleRecuperadoSesion) return

        // Nunca mostrar si el cache/memoria no es del día de hoy
        if (!this.cacheCumpleEsDeHoy()) {
          this.purgarCumpleCaducado()
          return
        }

        const cache = this.leerCacheCumple()
        const vistas = typeof cache.vistas === 'number' ? cache.vistas : 0
        const horariosMostrados = Array.isArray(cache.horariosMostrados)
          ? cache.horariosMostrados.slice()
          : []
        // Solo datos del cache de hoy (nunca this.cumple de otra fecha)
        const data = cache.data
        const slots = this.horariosCumpleFijos()

        if (vistas >= slots.length) return
        if (!(data && data.cumpleAnios && data.cumpleAnios.length)) return
        if (data.fechaCumple && data.fechaCumple !== fechaHoy) {
          this.purgarCumpleCaducado()
          return
        }

        const horarioActual = this.horarioCumpleActual()
        let slotKey = null

        if (slots.some((s) => s.key === horarioActual) && !horariosMostrados.includes(horarioActual)) {
          slotKey = horarioActual
        } else if (recuperacion) {
          const minutos = this.minutosAhora()
          // Slot pendiente más reciente (no el más antiguo): a las 16:30 → 16:07
          const pendientes = slots.filter((s) =>
            minutos >= s.minutos && !horariosMostrados.includes(s.key)
          )
          const pendiente = pendientes.length ? pendientes[pendientes.length - 1] : null
          if (!pendiente) return
          slotKey = pendiente.key
          this.cumpleRecuperadoSesion = true
        } else {
          return
        }

        horariosMostrados.push(slotKey)
        const nuevasVistas = vistas + 1
        const stamped = Object.assign({}, data, { fechaCumple: fechaHoy })
        this.cumple = stamped
        this.cumpleFechaSesion = fechaHoy
        this.dialogCumple = true
        localStorage.setItem('quienCumpleAnios', JSON.stringify({
          fecha: fechaHoy,
          vistas: nuevasVistas,
          horariosMostrados,
          consultadoEn: cache.consultadoEn || Date.now(),
          data: stamped
        }))
      },

      abrirModalCumple() {
        if (!this.hayCumpleHoy) return
        this.dialogCumple = true
      },

      partesHoraMexico(date = new Date()) {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'America/Mexico_City',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        }).formatToParts(date)
        const get = (type) => {
          const part = parts.find((p) => p.type === type)
          return part ? part.value : '00'
        }
        return {
          fecha: `${get('year')}-${get('month')}-${get('day')}`,
          hora: Number(get('hour')),
          minuto: Number(get('minute')),
          segundo: Number(get('second'))
        }
      },

      yaEsHoraReconocimiento() {
        const p = this.partesHoraMexico()
        return (p.hora * 60 + p.minuto) >= (17 * 60)
      },

      yaVioReconocimientoHoy() {
        if (this.esAdminReconocimientoSiempre) {
          return this.reconocimientoCerradoEstaSesion
        }
        return !!this.getReconocimientoMoisesVisto
      },

      marcarReconocimientoVisto() {
        this.marcarReconocimientoMoises()
      },

      detenerWatchReconocimiento() {
        if (this.reconocimientoTimer) {
          clearInterval(this.reconocimientoTimer)
          this.reconocimientoTimer = null
        }
      },

      iniciarWatchReconocimiento() {
        this.detenerWatchReconocimiento()
        if (!this.esReconocimientoMoisesHoy) return
        const tick = () => {
          if (!this.esReconocimientoMoisesHoy) {
            this.detenerWatchReconocimiento()
            this.dialogReconocimiento = false
            this.reconocimientoHoraLista = false
            return
          }
          if (!this.yaEsHoraReconocimiento()) return
          this.reconocimientoHoraLista = true
          this.intentarMostrarReconocimiento()
        }
        tick()
        this.reconocimientoTimer = setInterval(tick, 15000)
      },

      intentarMostrarReconocimiento() {
        if (!this.esReconocimientoMoisesHoy) return
        if (!this.yaEsHoraReconocimiento()) return
        if (this.yaVioReconocimientoHoy()) return
        if (this.dialogReconocimiento) return
        this.dialogCumple = false
        this.dialogReconocimiento = true
      },

      abrirModalReconocimiento() {
        if (!this.esReconocimientoMoisesHoy) return
        if (!this.yaEsHoraReconocimiento()) return
        this.dialogCumple = false
        this.dialogReconocimiento = true
      },

      /**
       * Género desde BD ERP: fyn_cat_trabajadores.idsexo
       * 1 = Masculino (H), 2 = Femenino (M)
       * Mixto hombre+mujer = X (tema beige)
       * Endpoint existente: trabajadores.erp.get.trabajadoreserp
       */
      async resolverGeneroCumple(cumplePayload) {
        const data = Object.assign({}, cumplePayload)

        const iderps = (data.cumpleAnios || [])
          .map((c) => c.iderp)
          .filter((id) => id != null && id !== '')

        if (!iderps.length) {
          data.genero = 'M'
          return data
        }

        try {
          const response = await this.$http.get('trabajadores.erp.get.trabajadoreserp', {
            params: { activos: 'Activos' }
          })
          const trabajadores = response.data || []
          const festejados = trabajadores.filter((t) =>
            iderps.some((id) => Number(id) === Number(t.id_usuario) || Number(id) === Number(t.nuevo_id_usuario))
          )

          const hayMujer = festejados.some((t) => Number(t.idsexo) === 2)
          const hayHombre = festejados.some((t) => Number(t.idsexo) === 1)

          if (hayHombre && hayMujer) {
            data.genero = 'X'
          } else if (hayHombre) {
            data.genero = 'H'
          } else {
            data.genero = 'M'
          }

          // Departamento real desde ERP (por si el API aún manda vacío/cache viejo)
          const deptos = [...new Set(
            festejados
              .map((t) => (t.departamento || '').trim())
              .filter(Boolean)
          )]
          if (deptos.length) {
            data.departamento = deptos.join(' , ')
          }
        } catch (e) {
          data.genero = 'M'
        }

        return data
      },

      validarRequisPendientes( ){

        this.$http.get('requisiciones.pendientes/' + this.getdatosUsuarioERPERP.iderp).then((response) => {

          if( response.data.length ){

            this.menu = []
            this.menuBusqueda = []

            this.$router.push({ name: 'Egresos' })

          }

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      validarObjetivosSemanales( ){

        let payload = {
          id_usuario: this.getdatosUsuarioERPERP.iderp,
          fecha: this.fecha
        }

        this.$http.post('objetivos.get', payload).then((response) => {

          if( !response.data.objetivos.length ){

            this.menu = []
            this.menuBusqueda = []

            this.$router.push({ name: 'ObjetivosSemanales' })

          }

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },


      obtenerEstatusLlamada(){
        this.$http.get('prospectos.llamadas/' + this.getdatosUsuarioERPERP.iderp).then((response) => {
          this.estatusLlamada = response.data.estatus
          this.cambiarEstatusLlamada(response.data.estatus)
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      enviarNewPass(){

        const pass = typeof this.newPass === 'string' ? this.newPass.trim() : '';
        if (!pass || pass.length < 8) {
          this.$notify({ group: 'foo', title: 'Contraseña', text: 'Debe tener al menos 8 caracteres.', type: 'warn' })
          return
        }

        // El API identifica al usuario por JWT (Authorization Bearer); solo enviamos la nueva contraseña.
        this.cargar = true
        this.$http.post('update.password', { newPass: pass }).then(() => {
          this.dialogNewPass = false
          this.newPass = ''
          this.salir()
        }).catch(error =>{
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'No fue posible actualizar la contraseña.'
          this.validarError(msg)
        }).finally(() => { this.cargar = false })
      },

      async getPermisos( ){

        // this.menu = []

        return this.$http.get('permisos.puestos.get/' + this.getdatosUsuarioERPERP.idpuesto + '/' + this.getdatosUsuarioERPERP.iderp ).then((response) => {

          this.disponibilidad_completa = response.data.disponibilidad_completa

          if( this.disponibilidad_completa == 0 ){
            this.$router.push({ name: 'Perfil'})
          }else{


            this.menu           = response.data.getMenusId

            const usuarioCalidad = esPuestoCalidad(this.getdatosUsuarioERPERP)

            // Excepciones individuales (lista en twilioUsuariosOnline.js): menú sin abrir puesto completo
            if (!usuarioCalidad && esExcepcionTwilioOnline(this.getdatosUsuarioERPERP.iderp)) {
              this.asegurarMenuTwilioOnline()
            }

            // 31, 568, 1312: acceso a Egresos + subir comprobantes de pago
            if (!usuarioCalidad) {
              this.menu = asegurarMenuEgresosComprobantes(
                this.menu,
                this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
              )
            }

            // Direcciones Empleados: solo iderp 1, 568, 1312 (se quita del menú al resto)
            this.menu = asegurarMenuDireccionesEmpleados(
              this.menu,
              this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
            )
            this.menu = asegurarMenuControlEquipos(
              this.menu,
              this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
            )

            // Naomi Palma (2781): Solicitar Cambio Horario + Acceso a CRM's
            this.menu = asegurarMenuNaomiPalma(
              this.menu,
              this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
            )

            this.menu = aplicarRestriccionMenuPorUsuario(
              this.menu,
              this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
            )
            this.menu = asegurarMenuAsistenciaAlumnos(
              this.menu,
              this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
            )
            this.asegurarMenuNominaColaboradores()

            if( !usuarioCalidad && [17,18,19,28,45,53,31,41,39,68,88].includes( this.getdatosUsuarioERPERP.idpuesto ) ){
              this.carrito_activo = true
              this.tareas_activas = true
            }

            this.menuBusqueda = []
            for( const i in this.menu ){
              const { items, title, path } = this.menu[i]
              if( items.length ){
                for( const j in items ){
                  if( items[j].items ){
                    for( const k in items[j].items ){
                      this.menuBusqueda.push({ title: title + ' / ' + items[j].title + ' / ' + items[j].items[k].title, path: items[j].items[k].path })
                    }
                  }else{
                    this.menuBusqueda.push({ title: title + ' / ' + items[j].title, path: items[j].path })
                  }
                }
              }
            }
            // Panel Grupo de Apoyo: visible en buscador si ya tienes Mapa Sucursales
            {
              const tieneMapa = this.menuBusqueda.some((x) => x && x.path === 'MapaSucursales')
              const tienePanel = this.menuBusqueda.some((x) => x && x.path === 'PanelGrupoApoyo')
              if (tieneMapa && !tienePanel) {
                this.menuBusqueda.push({
                  title: 'KPI / Panel Grupo de Apoyo',
                  path: 'PanelGrupoApoyo',
                })
              }
            }
            if (!usuarioCalidad) {
              if (Number(this.getdatosUsuarioERPERP.idpuesto) === 19) {
                this.menuBusqueda.push({ title: 'RI Grupos', path: 'rigrupos' })
              }
              this.inyectarNiGruposEnMenu()
              const idPuestoComercial = Number(this.getdatosUsuarioERPERP.idpuesto)
              const iderpUser = Number(this.getdatosUsuarioERPERP.iderp)
              if ([18, 19, 73].includes(idPuestoComercial) || iderpUser === 3108) {
                this.menuBusqueda.push({ title: 'Revision Agente IA / Guiones', path: 'GuionesRevision' })
              }
              if (esExcepcionTwilioOnline(this.getdatosUsuarioERPERP.iderp)) {
                this.menuBusqueda.push({ title: 'CRM Prospectos / WhatsApp / Twilio Online', path: 'TwilioOnline' })
              }
              if (esAccesoDireccionesEmpleados(this.getdatosUsuarioERPERP.iderp)) {
                this.menuBusqueda.push({ title: 'Direcciones Empleados', path: 'direccionesempleados' })
              }
              this.menuBusqueda.push({ title: 'Novedades del sistema', path: 'TimelineCambios' })
            }
            if (Number(this.getdatosUsuarioERPERP.iderp) === 3211) {
              this.menuBusqueda.push({ title: 'Operaciones / Alumnos / Asistencia alumnos', path: 'AsistenciaAlumnos' })
            }
            if (esExcepcionTwilioOnline(this.getdatosUsuarioERPERP.iderp)) {
              this.menuBusqueda.push({ title: 'CRM Prospectos / WhatsApp / Twilio Online', path: 'TwilioOnline' })
            }
            if (Number(this.getdatosUsuarioERPERP.iderp) === 2781) {
              this.menuBusqueda.push({ title: 'Administración / Control de equipos', path: 'ControlEquipos' })
            }
            this.menuBusqueda.push({ title: 'Novedades del sistema', path: 'TimelineCambios' })
          }

          // Admin finanzas (28): si hay pagos vencidos sin validar, solo vistas de validación
          const estadoBloqueoFinanzas = getEstadoBloqueoValidacionFinanzas()
          this.bloqueoValidacionFinanzas = estadoBloqueoFinanzas
          if (estadoBloqueoFinanzas.bloqueado) {
            this.menu = filtrarMenuBloqueoValidacionFinanzas(
              this.menu,
              this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp,
              true
            )
            this.menuBusqueda = (this.menuBusqueda || []).filter((el) => {
              return el && [
                'CorteDiario',
                'ValidarPagos',
                'ValidarIngresos',
                'EstadoCuentasBanco',
                'EstadoCuentasBancoDetalles',
              ].includes(el.path)
            })
          }

          this.addPermisos( this.menu )
          // this.menu = this.menu.filter( el => el.idmenu == 5 )

        }).catch( (error) => {
          const status = error.response && error.response.status
          if (status === 401 || status === 403) {
            this.limpiarApp()
            this.salirLogin()
            this.$router.replace({ name: 'Login', query: { reason: 'no-permisos' } }).catch(() => {})
          }
        }).finally( () => {
          this.cargar = false
        })
      },

      inyectarNiGruposEnMenu() {
        const niItem = {
          title: 'NI Grupos',
          path: 'nigrupos',
          icon: 'mdi-account-multiple-plus',
          color: 'teal darken-2',
          active: 0,
        }
        const yaExiste = (items) => items && items.some((x) => x && x.path === 'nigrupos')
        let inserted = false

        for (const m of this.menu || []) {
          if (!m.items || !m.items.length) continue
          for (let i = 0; i < m.items.length; i++) {
            const cat = m.items[i]
            if (cat.path === 'rigrupos' && !cat.items) {
              if (!yaExiste(m.items)) m.items.splice(i + 1, 0, { ...niItem })
              inserted = true
              break
            }
            if (cat.items && cat.items.length) {
              for (let j = 0; j < cat.items.length; j++) {
                if (cat.items[j].path === 'rigrupos') {
                  if (!yaExiste(cat.items)) cat.items.splice(j + 1, 0, { ...niItem })
                  inserted = true
                  break
                }
              }
            }
            if (inserted) break
          }
          if (inserted) break
        }

        if (!this.menuBusqueda.some((x) => x.path === 'nigrupos')) {
          this.menuBusqueda.push({ title: 'NI Grupos', path: 'nigrupos' })
        }
      },

      asegurarMenuNominaColaboradores () {
        if (!Array.isArray(this.menu)) this.menu = []

        if (!puedeVerMenuNominaColaboradores(this.getdatosUsuarioERPERP)) return

        const routeName = 'NominaColaboradores'
        const nuevoItem = {
          title: 'Nómina colaboradores',
          path: routeName,
          icon: 'mdi-account-group',
          color: null,
          active: 0,
        }

        const yaExiste = (items) => {
          if (!Array.isArray(items)) return false
          for (const it of items) {
            if (it && it.path === routeName) return true
            if (yaExiste(it.items)) return true
          }
          return false
        }

        if (yaExiste(this.menu)) return

        const agregarDespuesDeNomina = (items) => {
          if (!Array.isArray(items) || !items.length) return false
          for (let i = 0; i < items.length; i++) {
            const item = items[i]
            if (item && (item.path === 'Nomina' || item.path === 'nomina')) {
              items.splice(i + 1, 0, nuevoItem)
              return true
            }
            if (item && item.items && agregarDespuesDeNomina(item.items)) return true
          }
          return false
        }

        if (!agregarDespuesDeNomina(this.menu)) {
          this.menu.push({
            title: 'Recursos humanos',
            action: 'mdi-briefcase-account',
            active: false,
            items: [nuevoItem],
          })
        }

        if (!this.menuBusqueda.some((x) => x.path === routeName)) {
          this.menuBusqueda.push({ title: 'Nómina colaboradores', path: routeName })
        }
      },

      /**
       * Excepciones (twilioUsuariosOnline.js): CRM Prospectos → WhatsApp → Twilio Online.
       * Quien lo tenga por Catálogos → Permisos ya lo recibe del API; no se toca.
       */
      asegurarMenuTwilioOnline () {
        if (!Array.isArray(this.menu)) this.menu = []

        const norm = (t) => String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        const yaExiste = (items) => {
          if (!Array.isArray(items)) return false
          for (const it of items) {
            if (it && it.path === 'TwilioOnline') return true
            if (yaExiste(it.items)) return true
          }
          return false
        }
        if (yaExiste(this.menu)) return

        let menuCrm = this.menu.find((m) => {
          const t = norm(m && m.title)
          return t.includes('crm') && t.includes('prospect')
        })
        if (!menuCrm) {
          menuCrm = this.menu.find((m) => norm(m && m.title).includes('prospect'))
        }
        if (!menuCrm) {
          menuCrm = {
            title: 'CRM Prospectos',
            action: 'mdi-account-group',
            active: false,
            items: [],
          }
          this.menu.push(menuCrm)
        }
        if (!Array.isArray(menuCrm.items)) menuCrm.items = []

        let submenuWha = menuCrm.items.find((it) => {
          const t = norm(it && it.title)
          return t.includes('whatsapp') || t === 'whats app'
        })
        if (!submenuWha) {
          submenuWha = {
            title: 'WhatsApp',
            action: 'mdi-whatsapp',
            active: false,
            items: [],
          }
          menuCrm.items.push(submenuWha)
        }
        if (!Array.isArray(submenuWha.items)) submenuWha.items = []

        submenuWha.items.push({
          title: 'Twilio Online',
          path: 'TwilioOnline',
          color: null,
        })
      },

      salir(){
        this.salirLogin()
        // Mando a llamar la accion salir
        this.$router.push({name: 'Login'})
      },

      verProspecto (idprospecto) {
        this.abrirProspecto(idprospecto).then(response=>{
          if(this.$route.name != 'VerProspecto'){
            this.$router.push({name: 'VerProspecto'})
          }
        })
      },

      getCalendario( ){
        this.cargar = true
        // Obtener todos los ciclos
        this.$http.get('micalendario/' + this.getdatosUsuarioERPERP.iderp ).then(response=>{
          for( const i in response.data ){ response.data[i]['notificada'] = false }
          this.calendario = response.data
          this.actividadesHoy = response.data.filter( el => el.hoy == 1 ).length
          this.cargar = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async logDeviceInfo() {
        this.deviceInfo = await Device.getInfo();            //Angel Rodriguez
      },

      async logBatteryInfo() {
        this.batteryInfo = await Device.getBatteryInfo();    //Angel Rodriguez
      },

      cronometroSeguimiento( ){
        const momentoActual = new Date()
        const horaLocal   = momentoActual.getHours()
        const minutoLocal = momentoActual.getMinutes()
        const segundoLocal = momentoActual.getSeconds()
        const horaSistema = moment(horaLocal + ':' + minutoLocal + ':00','HH:mm:ss')

        this.timeAlerta = setTimeout(this.cronometroSeguimiento, 1000);

        if( minutoLocal == 0 && segundoLocal == 0 ){ this.alertaSeguimiento.estatus = true ; }
      },

      verNotificacion( item ){
        this.dialogNotifica.notificacion = item
        this.dialogNotifica.estatus = true
      },

      irAGlobal( ){

        window.open( 'https://globalsyntax.com.mx/' )
      },

      cargarPagosRechazados(){

        const ids = this.getdatosUsuarioERPERP.planteles.map(p => p.idplantel)

        this.cargarPagosRechazadosLista = true
        this.filtroPlantel = null
        this.filtroFechaInicioPagos = ''
        this.filtroFechaFinPagos = ''
        this.filtroTextoPagosRechazados = ''

        return this.$http.get('ingresos.obtener.pagos.rechazados', {
          params: { ids }
        })
        .then(response => {
          this.pagosRechazados = response.data || []
          this.dialogoPagosRechazados = true
        })
        .catch(() => {})
        .finally(() => { this.cargarPagosRechazadosLista = false });
        
      },

      fechaPagoSoloDia( fecha ) {
        if ( !fecha ) return ''
        return String( fecha ).substr( 0, 10 )
      },

      formatoFechaPago( fecha ) {
        if ( !fecha ) return '—'
        const valor = String( fecha )
        if ( valor.length >= 16 ) {
          return valor.substr( 0, 16 ).replace( 'T', ' ' )
        }
        return valor
      },

      formatoMonedaPagos( valor ) {
        const monto = Number( valor )
        if ( Number.isNaN( monto ) ) return '$0.00'
        return monto.toLocaleString( 'es-MX', { style: 'currency', currency: 'MXN' })
      },
      
      irAValidarPagos (item) {
        this.dialogoPagosRechazados = false
        this.$router.push({
          name: 'ValidarPagosSucursal',
          /*query: {
            plantel: item.plantel,
            id_ingreso: item.id_ingreso
          }*/
        })
      }

    },

    computed:{
      ...mapGetters('login',['getdatosUsuarioERPERP','getLogeado', 'getEscuela','getEstatusLlamada','getTareas','getNuevosProspectos','getReconocimientoMoisesVisto']),
      ...mapGetters('tema', ['getTema']),
      ...mapGetters('Carrito',['getCarrito']),

      esPuestoCalidadMenu() {
        if (esPuestoCalidad(this.getdatosUsuarioERPERP)) return true
        return menuSoloCalidad(this.menu)
      },

      bloqueoValidacionFinanzasActivo() {
        return !!(
          this.bloqueoValidacionFinanzas &&
          this.bloqueoValidacionFinanzas.bloqueado &&
          esUsuarioAdminFinanzas(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
        )
      },

      mostrarMenusLateralesExtra() {
        return !this.esPuestoCalidadMenu && !this.bloqueoValidacionFinanzasActivo
      },

      cumpleTemaClass() {
        return 'cumple-tema-beige'
      },

      cumplePronombre() {
        const genero = this.cumple && this.cumple.genero
        if (genero === 'H') return 'rodeado'
        if (genero === 'X') return 'rodeados'
        return 'rodeada'
      },

      hayCumpleHoy() {
        // Puesto Calidad: sin alertas ni ícono de cumpleaños
        if (this.esPuestoCalidadMenu) return false
        if (!this.cacheCumpleEsDeHoy()) return false
        if (this.cumpleFechaSesion && this.cumpleFechaSesion !== this.fechaLocalHoy()) return false
        return !!(this.cumple && this.cumple.cumpleAnios && this.cumple.cumpleAnios.length)
      },

      esReconocimientoMoisesHoy() {
        return false
      },

      esAdminReconocimientoSiempre() {
        return Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) === 334
      },

      esAmbienteStaging () {
        return process.env.VUE_APP_ENV === 'staging'
      },

      alerta() {
        return this.$store.state.alerta;
      },

      mostrarAlertaNovedades() {
        return this.novedadesHoy.count > 0 && !this.novedadesVistasHoy
      },

      notificacionesNoLeidas() {
        return (this.notificaciones || []).filter((el) => Number(el.visto) === 0).length
      },

      mostrarBadgeNotificaciones() {
        return this.notificacionesNoLeidas > 0
      },

      notificacionesBadgeContent() {
        const total = this.notificacionesNoLeidas
        if (!total) return ''
        return total > 99 ? '99+' : String(total)
      },

      actividadesHoyBadge() {
        if (!this.actividadesHoy) return ''
        return this.actividadesHoy > 99 ? '99+' : String(this.actividadesHoy)
      },

      carritoBadgeContent() {
        const total = this.getCarrito.length
        if (!total) return ''
        return total > 99 ? '99+' : String(total)
      },

      mostrarBtnPagosRechazados() {
        const u = this.getdatosUsuarioERPERP
        return u && [18, 19, 12, 11, 40].includes(u.idpuesto)
      },

      mostrarBtnCalendario() {
        const u = this.getdatosUsuarioERPERP
        return u
          && [11, 18, 31, 12, 58, 43, 73, 25, 48, 49, 74, 62, 54, 70, 75].includes(u.idpuesto)
          && ![1].includes(u.iderp)
      },

      mostrarBtnBitacora() {
        const u = this.getdatosUsuarioERPERP
        return u && [12, 18].includes(u.idpuesto)
      },

      plantelesUnicos () {
        const planteles = this.pagosRechazados
          .map((p) => p.plantel_alumno || p.plantel)
          .filter(Boolean)
        return [...new Set(planteles)].sort()
      },

      pagosRechazadosFiltrados () {
        let lista = this.pagosRechazados || []

        if ( this.filtroPlantel ) {
          lista = lista.filter((p) => (p.plantel_alumno || p.plantel) === this.filtroPlantel)
        }

        if ( this.filtroFechaInicioPagos ) {
          lista = lista.filter((p) => this.fechaPagoSoloDia( p.fecha_pago ) >= this.filtroFechaInicioPagos)
        }

        if ( this.filtroFechaFinPagos ) {
          lista = lista.filter((p) => this.fechaPagoSoloDia( p.fecha_pago ) <= this.filtroFechaFinPagos)
        }

        if ( this.filtroTextoPagosRechazados ) {
          const q = this.filtroTextoPagosRechazados.trim().toLowerCase()
          lista = lista.filter((p) => {
            const campos = [
              p.id_ingreso,
              p.fecha_pago,
              p.nombre_alumno,
              p.nombre_completo,
              p.plantel_alumno,
              p.plantel,
              p.motivo_rechazo,
              p.usuario_ingreso,
              p.monto_pagado,
            ]
            return campos.some((c) => String( c || '' ).toLowerCase().includes( q ))
          })
        }

        return lista
      },

      resumenPlantelesPagosRechazados () {
        const conteo = {}
        const lista = this.pagosRechazadosFiltrados

        for ( let i = 0; i < lista.length; i++ ) {
          const plantel = lista[i].plantel_alumno || lista[i].plantel || 'Sin plantel'
          conteo[plantel] = ( conteo[plantel] || 0 ) + 1
        }

        const entradas = Object.keys( conteo ).map(( plantel ) => ({
          plantel,
          total: conteo[plantel],
        }))

        if ( !entradas.length ) {
          return {
            mas: { plantel: '—', total: 0 },
            menos: { plantel: '—', total: 0 },
          }
        }

        entradas.sort(( a, b ) => b.total - a.total )

        return {
          mas: entradas[0],
          menos: entradas[entradas.length - 1],
        }
      },

    },
  };
</script>
<style>

  .app-bar-actions {
    align-items: center;
    display: flex;
    flex-shrink: 0;
    gap: 2px;
    margin-right: 4px;
  }

  .app-bar-action {
    align-items: center;
    display: inline-flex;
    justify-content: center;
    min-height: 44px;
    min-width: 44px;
    padding: 0 4px;
    position: relative;
  }

  .app-bar-btn {
    margin: 0 !important;
  }

  .app-bar-action .v-badge__badge {
    border: 2px solid #fff !important;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.18);
    font-size: 10px;
    font-weight: 700;
    height: 18px;
    line-height: 14px;
    min-width: 18px;
    padding: 0 4px;
  }

  .app-bar-action .v-badge--dot .v-badge__badge {
    border-radius: 50%;
    height: 10px;
    min-width: 10px;
    padding: 0;
    width: 10px;
  }

  .app-bar-notifications-menu {
    max-height: 400px;
  }

  .app-bar-notif-item:not(:last-child) {
    border-bottom: 1px solid #e5edf8;
  }

  .notification-clickable {
    cursor: pointer;
  }

  .notification-clickable:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

  .vue-notification-group {
    top: 72px !important;
    right: 16px !important;
    left: auto !important;
    width: auto !important;
    max-width: min(380px, calc(100vw - 32px)) !important;
    z-index: 9999 !important;
  }

  .vue-notification-wrapper {
    margin: 0 0 12px 0 !important;
    overflow: visible !important;
  }

  .vue-notification-template {
    box-sizing: border-box;
    min-width: 300px;
    max-width: 380px;
    padding: 14px 16px !important;
    border-radius: 12px !important;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.16) !important;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .vue-notification-template .notification-title {
    font-weight: 600;
    font-size: 14px;
    line-height: 1.35;
    margin: 0 0 6px 0;
  }

  .vue-notification-template .notification-content {
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
  }

  .notification-examen-ubicacion {
    color: #ffffff !important;
    padding: 14px 16px !important;
    box-sizing: border-box;
  }

  .notification-examen-ubicacion .notification-title,
  .notification-examen-ubicacion .notification-content {
    color: #ffffff !important;
  }

  .vue-notification-template.white {
    background: #ffffff !important;
    border: 1px solid #e3edf7 !important;
    color: #263238 !important;
    box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12) !important;
  }

  .vue-notification-template.white .notification-title {
    color: #102027 !important;
  }

  .vue-notification-template.white .notification-content {
    color: #455a64 !important;
  }

  .vue-notification-template.ticket-blue {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%) !important;
    border: 0 !important;
    border-left: 4px solid #0d47a1 !important;
    color: #ffffff !important;
  }

  .vue-notification-template.ticket-blue .notification-title,
  .vue-notification-template.ticket-blue .notification-content {
    color: #ffffff !important;
  }

  .vue-notification-template.success,
  .vue-notification-template.notification-examen-ubicacion {
    background: linear-gradient(135deg, #43a047 0%, #2e7d32 100%) !important;
    border-left: 4px solid #1b5e20 !important;
    color: #ffffff !important;
  }

  .vue-notification-template.success .notification-title,
  .vue-notification-template.success .notification-content,
  .vue-notification-template.notification-examen-ubicacion .notification-title,
  .vue-notification-template.notification-examen-ubicacion .notification-content {
    color: #ffffff !important;
  }

  .vue-notification-template.warn {
    background: linear-gradient(135deg, #fb8c00 0%, #ef6c00 100%) !important;
    border-left: 4px solid #e65100 !important;
    color: #ffffff !important;
  }

  .vue-notification-template.warn .notification-title,
  .vue-notification-template.warn .notification-content {
    color: #ffffff !important;
  }

  .vue-notification-template:not(.ticket-blue):not(.white):not(.success):not(.warn):not(.notification-examen-ubicacion) {
    background: #ffffff !important;
    border: 1px solid #e3edf7 !important;
    color: #263238 !important;
  }

  main{
    background: #f8f9fa ;
  }

  .v-navigation-drawer__content::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > .v-navigation-drawer__content::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-button:increment,.v-navigation-drawer__content::-webkit-scrollbar-button{
    display: none;
  }

  .v-navigation-drawer__content::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  .v-navigation-drawer__content::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  html{
    background: #f8f9fa;
  }

  .v-main__wrap{
    background: #f8f9fa !important;
  }

  .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 8px !important;
  }

  .v-application--is-ltr .v-list-item__action:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__avatar:last-of-type:not(:only-child), .v-application--is-ltr .v-list-item__icon:last-of-type:not(:only-child) {
    margin-left: 6px !important;
  }


  .v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
    align-self: center;
    margin: 0;
    min-width: 0px !important;
    justify-content: flex-end;
  }

  .shadowCard{
    border-radius: 8px !important;
    box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
  }

  .btn-login{
    background: rgb(0,26,252);
    background: linear-gradient(90deg, rgba(0,26,252,1) 0%, rgba(0,255,252,1) 100%);
  }

  .subrayado {
    text-decoration: underline;
  }


  #idScrollApp::-webkit-scrollbar {
    -webkit-appearance: none !important;
  }

  .v-data-table--fixed-header > #idScrollApp::-webkit-scrollbar:vertical {
    width: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar:vertical{
    width: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar-button:increment,#idScrollApp::-webkit-scrollbar-button{
    display: none;
  }

  #idScrollApp::-webkit-scrollbar:horizontal{
    height: 8px !important;
  }

  #idScrollApp::-webkit-scrollbar-thumb{
    background-color: #BABCBF;
    border-radius: 20px;
    border: 1px solid #ededed;
  }

  /*
spider
*/

@media screen and (min-width: 880px) {
#letters{
  font-size: 50px;
  position: absolute;
  top: 250px;
  left: 500px;
  width: 350px;
  -webkit-animation: change 5s linear infinite;
  -moz-animation: change 5s linear infinite;
  -ms-animation: change 5s linear infinite;
  -webkit-animation-delay: 2700ms;
  animation: change 5s linear infinite;
  animation-delay: 2700ms;
}
}
@-webkit-keyframes change{
  0%{
    opacity: 1;
  }25%{
    opacity: 0;
  }50%{
    opacity: 0;
  }100%{
    opacity: 1;
  }
}
@-moz-keyframes change{
  0%{
    opacity: 1;
  }25%{
    opacity: 0;
  }50%{
    opacity: 0;
  }100%{
    opacity: 1;
  }
}


@media screen and (min-width: 880px) {
  #spider1 {
    border: 3px solid black;
    width: 100px;
    height: 75px;
    border-radius: 50% 50%;
    box-shadow: inset 0px 0px 70px 0px black;
    position: absolute;
    top: -150px;
    left: 109px;
    z-index: 98;
    -webkit-animation: down 5s linear 1;
    -moz-animation: down 5s linear 1;
    -ms-animation: down 5s linear 1;
    animation-delay: 8s;
  }
}
@-webkit-keyframes down{
  0%{
    top: -350px;
  }50%{
    top: 350px;
  }
  100%{
    top: -150px;
  }
}
@-moz-keyframes down{
  0%{
    top: -350px;
  }
  25%{
    top:200px;
  }
  50%{
    top:400px;
  }
  100%{
    top:-700px;
  }
}
@media screen and (min-width: 880px) {
#eye{
  border: 4px solid black;
  width: 40px;
  height: 30px;
  background: white;
  border-radius: 50% 50%;
  position: absolute;
  top: -1px;
  left: 3px;
}
#eye:after{
  content: "";
  display: block;
  border: 4px solid black;
  width: 40px;
  height: 30px;
  background: white;
  border-radius: 50% 50%;
  position: absolute;
  top: -5px;
  left: 50px;
}
#pupil{
  border: 5px solid black;
  width: 2px;
  height: 2px;
  border-radius: 100%;
 background: black;
  position: absolute;
  top: -5px;
  left: 22px;
  box-shadow: 40px 1px 0px 0px black;
  z-index: 999;
  -webkit-animation: move 2s linear infinite;
  -moz-animation: move 2s linear infinite;
  -ms-animation: move 2s linear infinite;
}
}
@-webkit-keyframes move{
  0%{
    left: 22px;
  }
  25%{
    left: 37px;
  }
  50%{
    left: 10px;
  }
  75%{
    left: 15px;
  }100%{
    left: 22px;
  }
}
@-moz-keyframes move{
  0%{
    left: 22px;
  }
  25%{
    left: 37px;
  }
  50%{
    left: 10px;
  }
  75%{
    left: 15px;
  }100%{
    left: 22px;
  }
}
/*LEGS!!*/
@media screen and (min-width: 880px) {
#leg{
  -webkit-transform: rotate(-50deg);
  -moz-transform: rotate(-50deg);
  -ms-transform: rotate(-50deg);
  position: absolute;
  top: -14px;
  left: 94px;
  z-index: -998;
}
#leg p:nth-child(1){
  border: 6px solid black;
  border-bottom: transparent;
  border-left: transparent;
  border-radius: 5px;
  width: 40px;
  height: 10px;
}
#leg p:nth-child(2){
  border-top: 4px solid transparent;
  border-bottom: 2px solid transparent;
  border-left: 60px solid black;
  border-right: transparent;
  -webkit-transform: rotate(86deg);
  -moz-transform: rotate(86deg);
  -ms-transform: rotate(86deg);
  position: absolute;
  top: 30px;
  left: 13px;
}
#leg2{
  -webkit-transform: rotate(-8deg);
  -moz-transform: rotate(-8deg);
  -ms-transform: rotate(-8deg);
  position: absolute;
  top: 17px;
  left: 101px;

}
#leg2 p:nth-child(1){
  border: 6px solid black;
  border-bottom: transparent;
  border-left: transparent;
  border-radius: 5px;
  width: 40px;
  height: 10px;
}
#leg2 p:nth-child(2){
  border-top: 4px solid transparent;
  border-bottom: 2px solid transparent;
  border-left: 60px solid black;
  border-right: transparent;
  -webkit-transform: rotate(86deg);
  -moz-transform: rotate(86deg);
  -ms-transform: rotate(86deg);
  position: absolute;
  top: 30px;
  left: 13px;
}
#leg3{
  -webkit-transform: rotate(13deg);
  -moz-transform: rotate(13deg);
  -ms-transform: rotate(13deg);
  position: absolute;
  top: 45px;
  left: 91px;

}
#leg3 p:nth-child(1){
  border: 6px solid black;
  border-bottom: transparent;
  border-left: transparent;
  border-radius: 5px;
  width: 40px;
  height: 10px;
}
#leg3 p:nth-child(2){

  border-top: 4px solid transparent;
  border-bottom: 2px solid transparent;
  border-left: 60px solid black;
  border-right: transparent;
  -webkit-transform: rotate(86deg);
  -moz-transform: rotate(86deg);
  -ms-transform: rotate(86deg);
  position: absolute;
  top: 30px;
  left: 13px;
}


#leg4{
  -webkit-transform: rotatey(180deg)
    rotatez(-50deg);
  -moz-transform: rotatey(180deg)
    rotatez(-50deg);
  -ms-transform: rotatey(180deg)
    rotatez(-50deg);
  position: absolute;
  top: -14px;
  left: -33px;
  z-index: -998;
}
#leg4 p:nth-child(1){
  border: 6px solid black;
  border-bottom: transparent;
  border-left: transparent;
  border-radius: 5px;
  width: 40px;
  height: 10px;
}
#leg4 p:nth-child(2){
  border-top: 4px solid transparent;
  border-bottom: 2px solid transparent;
  border-left: 60px solid black;
  border-right: transparent;
  -webkit-transform: rotate(86deg);
  -moz-transform: rotate(86deg);
  -ms-transform: rotate(86deg);
  position: absolute;
  top: 30px;
  left: 13px;
}
#leg5{
  -webkit-transform: rotatey(180deg)
    rotatez(-20deg);
  -moz-transform: rotatey(180deg)
    rotatez(-24deg);
  -ms-transform: rotatey(180deg)
    rotatez(-24deg);
  position: absolute;
  top: 13px;
  left: -47px;
  z-index: -998;
}
#leg5 p:nth-child(1){
  border: 6px solid black;
  border-bottom: transparent;
  border-left: transparent;
  border-radius: 5px;
  width: 40px;
  height: 10px;
}
#leg5 p:nth-child(2){
  border-top: 4px solid transparent;
  border-bottom: 2px solid transparent;
  border-left: 60px solid black;
  border-right: transparent;
  -webkit-transform: rotate(86deg);
  -moz-transform: rotate(86deg);
  -ms-transform: rotate(86deg);
  position: absolute;
  top: 30px;
  left: 13px;
}

#leg6{
  -webkit-transform: rotatey(180deg)
    rotatez(15deg);
  -moz-transform: rotatey(180deg)
    rotatez(-50deg);
  -ms-transform: rotatey(180deg)
    rotatez(-50deg);
  position: absolute;
  top: 42px;
  left: -38px;

}
#leg6 p:nth-child(1){
  border: 6px solid black;
  border-bottom: transparent;
  border-left: transparent;
  border-radius: 5px;
  width: 40px;
  height: 10px;
}
#leg6 p:nth-child(2){

  border-top: 4px solid transparent;
  border-bottom: 2px solid transparent;
  border-left: 60px solid black;
  border-right: transparent;
  -webkit-transform: rotate(86deg);
  -moz-transform: rotate(86deg);
  -ms-transform: rotate(86deg);
  position: absolute;
  top: 30px;
  left: 13px;
}
#string{
  border: 2px solid black;
  height: 430px;
  width: 0px;
  position: absolute;
  top: -432px;
  left: 47px;
  -webkit-animation: down2 5s linear infinite;
  -webkit-animation-delay: 2000ms;
  position: absolute;

}
}

.pagos-rechazados-card {
  overflow: hidden;
}

.pagos-rechazados-header {
  background: linear-gradient(135deg, #fff5f5 0%, #ffffff 100%);
}

.pagos-rechazados-stat {
  background: #fafafa;
  border-color: #eceff1 !important;
  height: 100%;
}

.pagos-rechazados-filtros {
  background: #f8fafc;
  border-color: #e2e8f0 !important;
}

.pagos-rechazados-table tbody tr {
  cursor: pointer;
}

.pagos-rechazados-table tbody tr:hover {
  background: #fff8f8 !important;
}

.pagos-rechazados-motivo {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
  max-width: 280px;
}

/* —— Modal cumpleaños (solo diseño) —— */
.cumple-dialog {
  border-radius: 24px !important;
  box-shadow: 0 24px 64px rgba(45, 31, 24, 0.22) !important;
  overflow: hidden;
}

.cumple-card {
  background: #fff !important;
  border-radius: 24px !important;
  overflow: hidden;
  position: relative;
}

.cumple-close {
  background: rgba(255, 255, 255, 0.72) !important;
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 10px rgba(45, 31, 24, 0.1);
  color: var(--cumple-accent, #9a5b5b) !important;
  position: absolute !important;
  right: 12px;
  top: 12px;
  z-index: 5;
  transition: background 0.2s ease, transform 0.2s ease;
}

.cumple-close:hover {
  background: #fff !important;
  transform: scale(1.06);
}

.cumple-modal {
  padding-bottom: 8px;
}

/* Tema único beige (todos los géneros) */
.cumple-tema-beige {
  --cumple-bg-1: #f5efe6;
  --cumple-bg-2: #ebe2d4;
  --cumple-bg-3: #ddd0bc;
  --cumple-accent: #a89070;
  --cumple-accent-soft: #7a654c;
  --cumple-chip-bg: linear-gradient(135deg, #faf6f0 0%, #efe6d8 100%);
  --cumple-chip-border: rgba(168, 144, 112, 0.3);
  --cumple-spout-a: #c4b09a;
  --cumple-spout-b: #a89070;
  --cumple-spout-c: #967c5c;
  --cumple-spout-d: #7a654c;
}

.cumple-tema-mujer,
.cumple-tema-hombre,
.cumple-tema-mixto {
  /* compat: alias al beige único */
  --cumple-bg-1: #f5efe6;
  --cumple-bg-2: #ebe2d4;
  --cumple-bg-3: #ddd0bc;
  --cumple-accent: #a89070;
  --cumple-accent-soft: #7a654c;
  --cumple-chip-bg: linear-gradient(135deg, #faf6f0 0%, #efe6d8 100%);
  --cumple-chip-border: rgba(168, 144, 112, 0.3);
  --cumple-spout-a: #c4b09a;
  --cumple-spout-b: #a89070;
  --cumple-spout-c: #967c5c;
  --cumple-spout-d: #7a654c;
}

.cumple-cake-stage {
  align-items: center;
  background:
    radial-gradient(ellipse 80% 60% at 50% 100%, rgba(255, 255, 255, 0.55) 0%, transparent 65%),
    linear-gradient(165deg, var(--cumple-bg-1) 0%, var(--cumple-bg-2) 45%, var(--cumple-bg-3) 100%);
  display: flex;
  height: 320px;
  justify-content: center;
  overflow: hidden;
  padding: 8px 0 36px;
  position: relative;
}

.cumple-glow {
  background: radial-gradient(circle, rgba(255, 255, 255, 0.7) 0%, transparent 70%);
  border-radius: 50%;
  bottom: 48px;
  height: 160px;
  left: 50%;
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  width: 280px;
  z-index: 0;
}

.cumple-orb {
  background: rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  pointer-events: none;
  position: absolute;
  z-index: 0;
}

.cumple-orb--1 {
  animation: cumple-float 7s ease-in-out infinite;
  height: 90px;
  left: -20px;
  top: 24px;
  width: 90px;
}

.cumple-orb--2 {
  animation: cumple-float 9s ease-in-out 1s infinite reverse;
  height: 56px;
  right: 18px;
  top: 40px;
  width: 56px;
}

.cumple-orb--3 {
  animation: cumple-float 8s ease-in-out 0.5s infinite;
  bottom: 56px;
  height: 36px;
  left: 18%;
  width: 36px;
}

.cumple-sparkle {
  animation: cumple-twinkle 2.4s ease-in-out infinite;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.9);
  height: 5px;
  position: absolute;
  width: 5px;
  z-index: 1;
}

.cumple-sparkle.s1 { left: 18%; top: 28%; animation-delay: 0s; }
.cumple-sparkle.s2 { right: 20%; top: 22%; animation-delay: 0.6s; height: 4px; width: 4px; }
.cumple-sparkle.s3 { left: 28%; top: 58%; animation-delay: 1.1s; height: 3px; width: 3px; }
.cumple-sparkle.s4 { right: 26%; top: 52%; animation-delay: 1.7s; }

.cumple-wave {
  bottom: -1px;
  display: block;
  height: 28px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 2;
}

.cumple-cake {
  filter: drop-shadow(0 14px 20px rgba(107, 68, 51, 0.18));
  margin-top: 18px;
  position: relative;
  width: 248px;
  z-index: 1;
}

.cumple-cake-svg {
  display: block;
  height: auto;
  overflow: visible;
  width: 100%;
}

/* Boquilla de la máquina */
.cake-spout .spout-a { fill: var(--cumple-spout-a, #d4a0a8); }
.cake-spout .spout-b { fill: var(--cumple-spout-b, #c47884); }
.cake-spout .spout-c { fill: var(--cumple-spout-c, #b86a76); }
.cake-spout .spout-d { fill: var(--cumple-spout-d, #a85c68); }

.cake-spout {
  animation:
    cake-spout-bob 0.4s ease-in-out 0.2s 8 alternate,
    cake-spout-fade 0.35s ease 3.3s forwards;
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center top;
  animation-fill-mode: both;
}

@keyframes cake-spout-bob {
  0% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 1;
    transform: translateY(4px);
  }
}

@keyframes cake-spout-fade {
  to {
    opacity: 0;
    transform: translateY(-8px);
  }
}

/* Gotas de mezcla (máquina → pastel) */
.batter-drop {
  opacity: 0;
  transform-box: fill-box;
  transform-origin: center;
}

.batter-drop.drop-1 {
  animation: batter-pour 0.55s cubic-bezier(0.4, 0.05, 0.6, 1) 0.35s both;
}

.batter-drop.drop-2 {
  animation: batter-pour 0.55s cubic-bezier(0.4, 0.05, 0.6, 1) 0.95s both;
}

.batter-drop.drop-3 {
  animation: batter-pour 0.55s cubic-bezier(0.4, 0.05, 0.6, 1) 1.55s both;
}

.batter-drop.drop-4 {
  animation: batter-pour-icing 0.5s cubic-bezier(0.4, 0.05, 0.6, 1) 2.25s both;
}

@keyframes batter-pour {
  0% {
    opacity: 0;
    transform: translateY(0) scale(0.55);
  }
  12% {
    opacity: 1;
    transform: translateY(8px) scale(0.85);
  }
  70% {
    opacity: 1;
    transform: translateY(105px) scale(1.15, 0.75);
  }
  85% {
    opacity: 0.85;
    transform: translateY(118px) scale(1.35, 0.55);
  }
  100% {
    opacity: 0;
    transform: translateY(122px) scale(1.6, 0.2);
  }
}

@keyframes batter-pour-icing {
  0% {
    opacity: 0;
    transform: translateY(0) scale(0.5);
  }
  15% {
    opacity: 1;
    transform: translateY(6px) scale(0.9);
  }
  70% {
    opacity: 1;
    transform: translateY(55px) scale(1.2, 0.7);
  }
  100% {
    opacity: 0;
    transform: translateY(62px) scale(1.5, 0.25);
  }
}

/* Capas: aparecen con “squash” al aterrizar la mezcla */
.cake-part {
  opacity: 0;
  transform: translateY(-18px) scale(0.72, 0.35);
  transform-box: fill-box;
  transform-origin: center bottom;
}

.cake-plate {
  animation: cake-plate-in 0.4s ease-out 0.05s forwards;
  transform-origin: center;
}

.cake-base {
  animation: cake-layer-splat 0.5s cubic-bezier(0.2, 1.3, 0.35, 1) 0.75s forwards;
}

.cake-mid {
  animation: cake-layer-splat 0.5s cubic-bezier(0.2, 1.3, 0.35, 1) 1.35s forwards;
}

.cake-top {
  animation: cake-layer-splat 0.5s cubic-bezier(0.2, 1.3, 0.35, 1) 1.95s forwards;
}

.cake-icing {
  animation: cake-layer-splat 0.5s cubic-bezier(0.2, 1.3, 0.35, 1) 2.55s forwards;
}

.cake-candle {
  animation: cake-candle-drop 0.45s cubic-bezier(0.22, 1.2, 0.36, 1) 3.05s forwards;
  transform: translateY(-40px) scale(1);
  transform-origin: center bottom;
}

.cake-flame,
.cake-flame-core {
  animation: cumple-flicker-svg 1.1s ease-in-out 3.4s infinite alternate;
  transform-box: fill-box;
  transform-origin: center bottom;
}

/* Confeti + globos cortos al terminar el pastel */
.cumple-fiesta {
  bottom: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 4;
}

.fiesta-confetti {
  border-radius: 2px;
  height: 8px;
  opacity: 0;
  position: absolute;
  top: 18%;
  width: 6px;
}

.fiesta-confetti.c1 {
  background: #e86a7a;
  left: 18%;
  animation: fiesta-confetti-fall 1.1s ease-in 3.45s both;
}
.fiesta-confetti.c2 {
  background: #5b9bd5;
  left: 38%;
  width: 7px;
  height: 5px;
  animation: fiesta-confetti-fall 1s ease-in 3.52s both;
}
.fiesta-confetti.c3 {
  background: #f0c24b;
  left: 55%;
  border-radius: 50%;
  animation: fiesta-confetti-fall 1.15s ease-in 3.48s both;
}
.fiesta-confetti.c4 {
  background: #7cbc6e;
  left: 72%;
  width: 5px;
  height: 9px;
  animation: fiesta-confetti-fall 1.05s ease-in 3.55s both;
}
.fiesta-confetti.c5 {
  background: #c48ad9;
  left: 88%;
  animation: fiesta-confetti-fall 1.1s ease-in 3.5s both;
}

.fiesta-balloon {
  border-radius: 50% 50% 50% 50% / 45% 45% 55% 55%;
  height: 28px;
  opacity: 0;
  position: absolute;
  bottom: 22%;
  width: 20px;
}

.fiesta-balloon::after {
  background: currentColor;
  bottom: -10px;
  content: '';
  height: 12px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 1.5px;
}

.fiesta-balloon.b1 {
  background: #e86a7a;
  color: #c45565;
  left: 10%;
  animation: fiesta-balloon-up 1.25s ease-out 3.5s both;
}
.fiesta-balloon.b2 {
  background: #5b9bd5;
  color: #4a82b5;
  left: 48%;
  height: 24px;
  width: 17px;
  animation: fiesta-balloon-up 1.2s ease-out 3.58s both;
}
.fiesta-balloon.b3 {
  background: #f0c24b;
  color: #d4a83a;
  left: 82%;
  height: 26px;
  width: 18px;
  animation: fiesta-balloon-up 1.3s ease-out 3.54s both;
}

@keyframes fiesta-confetti-fall {
  0% {
    opacity: 0;
    transform: translateY(0) rotate(0deg);
  }
  12% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(150px) rotate(220deg);
  }
}

@keyframes fiesta-balloon-up {
  0% {
    opacity: 0;
    transform: translateY(20px) scale(0.7);
  }
  15% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  70% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(-110px) scale(0.95);
  }
}

@keyframes cake-plate-in {
  from {
    opacity: 0;
    transform: scale(0.85);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes cake-layer-splat {
  0% {
    opacity: 0;
    transform: translateY(-14px) scale(0.55, 0.2);
  }
  55% {
    opacity: 1;
    transform: translateY(3px) scale(1.06, 0.88);
  }
  75% {
    opacity: 1;
    transform: translateY(-2px) scale(0.97, 1.05);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1, 1);
  }
}

@keyframes cake-candle-drop {
  0% {
    opacity: 0;
    transform: translateY(-40px);
  }
  70% {
    opacity: 1;
    transform: translateY(3px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes cumple-flicker-svg {
  from {
    transform: scale(1) rotate(-3deg);
  }
  to {
    transform: scale(1.1) rotate(3deg);
  }
}

@keyframes cumple-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes cumple-twinkle {
  0%, 100% { opacity: 0.25; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1.25); }
}

@keyframes cumple-copy-in {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.cumple-copy {
  padding: 8px 32px 32px;
  text-align: center;
}

.cumple-eyebrow {
  color: var(--cumple-accent, #c47884);
  font-family: 'Outfit', 'Roboto', sans-serif;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  margin: 0 0 10px;
  text-transform: uppercase;
}

.cumple-greeting {
  color: #6b4433;
  font-family: 'Caveat', cursive;
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1.15;
  margin: 0 0 6px;
}

.cumple-name {
  color: #2a1c16;
  font-family: 'Fredoka', 'Outfit', sans-serif;
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.3;
  margin: 0 0 14px;
  text-transform: uppercase;
}

.cumple-depto-chip {
  align-items: center;
  background: var(--cumple-chip-bg, linear-gradient(135deg, #fff1f3 0%, #fde8eb 100%));
  border: 1px solid var(--cumple-chip-border, rgba(196, 120, 132, 0.22));
  border-radius: 999px;
  color: var(--cumple-accent-soft, #9a5b5b);
  display: inline-flex;
  font-family: 'Outfit', 'Roboto', sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
  letter-spacing: 0.02em;
  margin-bottom: 18px;
  padding: 6px 14px 6px 10px;
}

.cumple-msg {
  color: #5a463c;
  font-family: 'Nunito', 'Roboto', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.55;
  margin: 0 auto 12px;
  max-width: 400px;
}

.cumple-msg--last {
  color: #6b4433;
  font-weight: 700;
  margin-bottom: 0;
}

.cumple-msg--last {
  color: #6b4433;
  font-weight: 500;
  margin-bottom: 0;
}

.recon-dialog {
  border-radius: 24px !important;
  box-shadow: 0 20px 48px rgba(120, 140, 170, 0.16) !important;
  max-height: 92vh;
  overflow: hidden;
}

.recon-card {
  background: #fff !important;
  border-radius: 24px !important;
  max-height: 92vh;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  scrollbar-color: rgba(176, 140, 144, 0.45) transparent;
  scrollbar-width: thin;
}

.recon-card::-webkit-scrollbar {
  width: 4px;
}

.recon-card::-webkit-scrollbar-track {
  background: transparent;
}

.recon-card::-webkit-scrollbar-thumb {
  background: rgba(176, 140, 144, 0.45);
  border-radius: 999px;
}

.recon-close {
  background: rgba(255, 255, 255, 0.72) !important;
  box-shadow: 0 2px 10px rgba(24, 87, 164, 0.12);
  color: #1857a4 !important;
  position: absolute !important;
  right: 12px;
  top: 12px;
  z-index: 5;
}

.recon-stage {
  align-items: center;
  background:
    radial-gradient(ellipse 80% 60% at 50% 100%, rgba(255, 255, 255, 0.5) 0%, transparent 65%),
    linear-gradient(135deg, #c5d9ee 0%, #dce4ee 42%, #edd6d8 100%);
  display: flex;
  height: 168px;
  justify-content: center;
  overflow: hidden;
  padding: 4px 0 28px;
  position: relative;
}

.recon-glow {
  background: radial-gradient(circle, rgba(255, 255, 255, 0.7) 0%, transparent 70%);
  border-radius: 50%;
  bottom: 28px;
  height: 120px;
  left: 50%;
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  width: 220px;
}

.recon-orb {
  background: rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  pointer-events: none;
  position: absolute;
}

.recon-orb--1 {
  animation: recon-float 7s ease-in-out infinite;
  height: 70px;
  left: -16px;
  top: 16px;
  width: 70px;
}

.recon-orb--2 {
  animation: recon-float 9s ease-in-out 1s infinite reverse;
  height: 44px;
  right: 16px;
  top: 28px;
  width: 44px;
}

.recon-orb--3 {
  animation: recon-float 8s ease-in-out 0.5s infinite;
  bottom: 36px;
  height: 28px;
  left: 18%;
  width: 28px;
}

.recon-sparkle {
  animation: recon-twinkle 2.4s ease-in-out infinite;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(255, 255, 255, 0.9);
  height: 5px;
  position: absolute;
  width: 5px;
}

.recon-sparkle.s1 { left: 18%; top: 28%; }
.recon-sparkle.s2 { animation-delay: 0.6s; height: 4px; right: 20%; top: 22%; width: 4px; }
.recon-sparkle.s3 { animation-delay: 1.1s; height: 3px; left: 28%; top: 58%; width: 3px; }
.recon-sparkle.s4 { animation-delay: 1.7s; right: 26%; top: 52%; }

.recon-wave {
  bottom: -1px;
  display: block;
  height: 28px;
  left: 0;
  position: absolute;
  width: 100%;
  z-index: 2;
}

.recon-star {
  animation: recon-float 4.5s ease-in-out infinite;
  filter: drop-shadow(0 10px 16px rgba(201, 162, 39, 0.35));
  position: relative;
  width: 112px;
  z-index: 1;
}

.recon-star-svg {
  display: block;
  height: auto;
  width: 100%;
}

.recon-fiesta {
  bottom: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 4;
}

.recon-confetti {
  border-radius: 2px;
  height: 8px;
  opacity: 0;
  position: absolute;
  top: 18%;
  width: 6px;
}

.recon-confetti.c1 { animation: recon-confetti-fall 1.1s ease-in 0.05s both; background: #8eb0d4; left: 18%; }
.recon-confetti.c2 { animation: recon-confetti-fall 1s ease-in 0.12s both; background: #b7cce4; height: 5px; left: 38%; width: 7px; }
.recon-confetti.c3 { animation: recon-confetti-fall 1.15s ease-in 0.08s both; background: #fff; border-radius: 50%; left: 55%; }
.recon-confetti.c4 { animation: recon-confetti-fall 1.05s ease-in 0.16s both; background: #e0b8bb; height: 9px; left: 72%; width: 5px; }
.recon-confetti.c5 { animation: recon-confetti-fall 1.1s ease-in 0.1s both; background: #d4a8ab; left: 88%; }

.recon-balloon {
  border-radius: 50% 50% 50% 50% / 45% 45% 55% 55%;
  bottom: 22%;
  height: 28px;
  opacity: 0;
  position: absolute;
  width: 20px;
}

.recon-balloon::after {
  background: currentColor;
  bottom: -10px;
  content: '';
  height: 12px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 1.5px;
}

.recon-balloon.b1 { animation: recon-balloon-up 1.25s ease-out 0.05s both; background: #a9c6e4; color: #7a9bbd; left: 10%; }
.recon-balloon.b2 { animation: recon-balloon-up 1.2s ease-out 0.12s both; background: #c5d4e6; color: #8aa0b8; height: 24px; left: 48%; width: 17px; }
.recon-balloon.b3 { animation: recon-balloon-up 1.3s ease-out 0.08s both; background: #e4c4c6; color: #c9a0a3; height: 26px; left: 82%; width: 18px; }

.recon-copy {
  padding: 8px 32px 32px;
  text-align: center;
}

.recon-copy--fast {
  background: linear-gradient(180deg, #fff 0%, #fdf6f6 100%);
  padding-top: 4px;
  padding-bottom: 28px;
}

.recon-copy--fast .recon-greeting {
  color: #c45c62;
}

.recon-chip--fast {
  background: linear-gradient(135deg, #fff6f6 0%, #fdeeee 100%);
  border-color: rgba(196, 92, 98, 0.35);
  color: #c45c62;
}

.recon-copy--fast .recon-msg {
  color: #6b4548;
}

.recon-eyebrow {
  color: #C9A227;
  font-family: 'Outfit', 'Roboto', sans-serif;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  margin: 0 0 10px;
  text-transform: uppercase;
}

.recon-greeting {
  color: #1857a4;
  font-family: 'Caveat', cursive;
  font-size: 1.9rem;
  font-weight: 700;
  line-height: 1.15;
  margin: 0 0 6px;
}

.recon-name {
  color: #0b3d78;
  font-family: 'Fredoka', 'Outfit', sans-serif;
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1.3;
  margin: 0 0 14px;
  text-transform: uppercase;
}

.recon-chip {
  align-items: center;
  background: linear-gradient(135deg, #f4f9ff 0%, #fff8e6 100%);
  border: 1px solid rgba(201, 162, 39, 0.45);
  border-radius: 999px;
  color: #1857a4;
  display: inline-flex;
  font-family: 'Outfit', 'Roboto', sans-serif;
  font-size: 0.8rem;
  font-weight: 500;
  margin-bottom: 18px;
  padding: 6px 14px 6px 10px;
}

.recon-msg {
  color: #3a5570;
  font-family: 'Nunito', 'Roboto', sans-serif;
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 auto 12px;
  max-width: 460px;
}

.recon-msg--last {
  color: #1857a4;
  font-weight: 500;
  margin-bottom: 0;
}

@keyframes recon-float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

@keyframes recon-twinkle {
  0%, 100% { opacity: 0.25; transform: scale(0.8); }
  50% { opacity: 1; transform: scale(1.25); }
}

@keyframes recon-confetti-fall {
  0% { opacity: 0; transform: translateY(0) rotate(0deg); }
  12% { opacity: 1; }
  85% { opacity: 1; }
  100% { opacity: 0; transform: translateY(150px) rotate(220deg); }
}

@keyframes recon-balloon-up {
  0% { opacity: 0; transform: translateY(20px) scale(0.7); }
  15% { opacity: 1; transform: translateY(0) scale(1); }
  70% { opacity: 1; }
  100% { opacity: 0; transform: translateY(-110px) scale(0.95); }
}

</style>
